import { Component, OnInit, Output, EventEmitter, ViewChild, ViewChildren, ViewEncapsulation, ElementRef, ChangeDetectorRef, OnDestroy, Renderer2, HostListener, QueryList, AfterViewInit } from '@angular/core';
import { animate, state, style, transition, trigger, group } from '@angular/animations';
import { DemoService } from '../../shared/demo.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
//import { request } from 'http';
//import { MatTableDataSource } from '@angular/material';
//import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator, fadeInContent } from '@angular/material';
//import { VquadbtfxoComponent } from 'src/app/statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
//import { parse } from 'querystring';
//import { NWSTAT_VQUAD } from 'src/app/shared/models/NWSTAT_VQUAD';
//import { NWSTAT_VQUAD_CENTRALIPS } from 'src/app/shared/models/NWSTAT_VQUAD_CENTRALIPS';
//import { SelectionModel } from '@angular/cdk/collections';
//import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
//import { Chart, ChartType, ChartOptions } from 'chart.js';
//import { ChartsModule } from 'ng2-charts';
//import { strictEqual } from 'assert';
//import { E } from '@angular/cdk/keycodes';
import { Router, ActivatedRoute } from '@angular/router';
//import { SelectItem, Keys } from 'lib/common';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { DataFilter } from 'lib/ng-data-table/base';
import { DatePipe } from '@angular/common';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import html2canvas from 'html2canvas';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
//import WaveSurfer from 'wavesurfer.js';
//import { saveAs } from 'file-saver';
//import * as fs from 'fs';
//import { catchError  } from 'rxjs/operators';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { ITimeUpdateEvent, NgWaveformComponent, IRegionPositions } from 'ng-waveform';
import { AudioPlayerPopupComponent } from '../audio-player-popup/audio-player-popup.component';
import { SelectItem } from 'lib/common';
import { parse } from 'querystring';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';
import { FormControl } from '@angular/forms';
import { catchError } from 'rxjs/operators';
//import { Path } from 'leaflet';

//declare var WaveSurfer;

@Component({
  selector: 'app-itsviewer',
  templateUrl: './itsviewer.component.html',
  styleUrls: ['./itsviewer.component.scss']
})
export class ITSViewerComponent implements OnInit {
  pcmData: ArrayBuffer;
  wavUrl: SafeUrl;
  audioURL: string = "/Webviewer/assets/audio/audioTemp.wav";

  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;
  // boolean variable to track mouse state
  isMouseOver = false;

  //susheel 
  rsltType: string = "itsviewer";
  rsltTypeTS = '-1';
  TSSelected: number;
  AutoRefreshInfo: any;
  title: string = "ITS Viewer";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();
  xaxis: any;
  yaxis: any;
  dx: any;
  dy: any;
  distsqrt: any;
  distsqrtxy: any;

  baseUrl: string;
  url: string;
  isLoading = false;
  noRecordFound = false;
  private commonFilter: CommonFilter;
  private dataFilter: DataFilter;
  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;
  AllGeneralFilter = [];
  clearAllFiltersBool = false;
  delFilterColName = '';
  filters = {};
  //delFilterColName = '';
  filtersWithEventID = {};
  interval;

  name = 'Angular';
  pointSize = 8;
  element: Element;
  root: Element;
  ctx: any;
  canvas: any;
  selectedIVQFile: File = null;
  fileUPImage: File = null;
  fileUPRTS: File = null;
  fileUPIVQ: File = null;
  fileUPPCM: File = null;
  selectedRTSFileToUpload: File = null;
  selectedAllPCMFiles: File[] = [];
  imageURL: any;
  showITSMap: boolean = false;
  showImageError: boolean = false;
  ShowImageErrorMsg: string = "";
  showRTSFileError: boolean = false;
  ShowRTSFileErrorMsg: string = "";
  showIVQFileError: boolean = false;
  ShowIVQFileErrorMsg: string = "";
  showPCMFileError: boolean = false;
  ShowPCMFileErrorMsg: string = "";
  selectedImageFile: File = null;
  modelPinColorExcellent: string = "#008040";
  modelPinColorGood: string = "#00FF00";
  modelPinColorFair: string = "#004080";
  modelPinColorPoor: string = "#FF0000";
  modelPinColorPass: string = "#008040";
  modelPinColorFail: string = "#004080";
  editingPinColor: boolean = true;
  excellentScore: number = 4;
  goodScrore: number = 3;
  fairScore: number = 2;
  poorScore: number = 1;
  daqScore: number = 0;
  filteredDAQPesqScore: any;
  selectedTab: string = "VQT";
  selectedTabIndex: string = "0"
  showRating: boolean = false;
  showVQT: boolean = true;
  showLeftPanel: boolean = true;
  colorRatingError: string = "";
  imageFileName: string = "";
  rtsFileName: string = "";
  ivqFileName: string = "";
  firstTimeFunctionCall: boolean = false;
  daqScoreResult: string = "";
  windowMinimized: boolean = false;
  pcmFolderName: string = "";// "C:\\Users\\Elumalai\\Desktop\\ICON\\POLQANB";
  selectedSampleRate: string[] = ['8000'];
  selectedFilter: string = "Remote";
  isRemoteSystem: boolean = true;
  isAudioChecked: boolean = false;
  isSaveITSFilePath: boolean = false;
  isPCMFolderPath: boolean = false;

  isPlaying: boolean = false;
  SelectedImageFileIUpload_RemoteSystem: File = null;
  SelectedIVQFileUpload_RemoteSystem: File = null;
  SelectedImageFile_RemoteSystem: string = "";
  SelectedRTSFile_RemoteSystem: string = "";
  SelectedIVQFile_RemoteSystem: string = "";
  imageFileName_RemoteSystem: string = "\\\\192.168.1.41\\Shared WvSQL\\ITS\\ITS\\POLQA\\Industrial Style Office.jpg";
  rtsFileName_RemoteSystem: string = "\\\\192.168.1.41\\Shared WvSQL\\ITS\\ITS\\POLQA\\Office3Dimage032120231756.rts";
  ivqFileName_RemoteSystem: string = "\\\\192.168.1.41\\Shared WvSQL\\ITS\\ITS\\POLQA\\Office3Dimage032120231756.ivq";
  pcmFolderName_RemoteSystem: string = "C:\\VQT_Degraded"; /// C:\\VQT_Degraded -- default server path
  showGeneralError: boolean = false;
  ShowGeneralErrorMsg: string = "";
  rtsFileData_RemoteSystem: any = [];
  showLoader: boolean = false;
  resultType = "";
  folderPath_RemoteSystem: string = "C:\\Program Files (x86)\\GL Communications Inc\\VQT\\ITS";   /// C:\\Program Files (x86)\\GL Communications Inc\\VQT\\ITS -- default server path
  imagePlaceholder = 'Select Image File';
  rtsPlaceholder = 'Select RTS File';
  ivqPlaceholder = 'Select IVQ File';
  pcmPlaceholder = 'Select PCM Folder';
  critErrorDesc: string = "";

  //@ViewChild('waveform', { static: true }) waveformElement: ElementRef;
  //private wavesurfer: WaveSurfer;

  ///////////////////////////////Region names section ------------------------- dropdown
  ///////// Image
  @ViewChild('inputImage', { static: false }) inputCtrlImage;
  controlImage = new FormControl();

  toHighlightImage: string = '';
  imageNamesObservable: string[];
  imageNames: string[] = [];
  selectedImageNames: string[] = [];
  imageNameDetailList = [];

  modelImageName: string = "";
  editingImageName: boolean = true;
  critErrorsImageName: boolean = false;

  modelImageColor: string = "#ffffff";
  editingImageColor: boolean = true;

  ////////// RTS
  @ViewChild('inputRTS', { static: false }) inputCtrlRTS;
  controlRTS = new FormControl();

  toHighlightRTS: string = '';
  rtsNamesObservable: string[];
  rtsNames: string[] = [];
  selectedRTSNames: string[] = [];
  rtsNameDetailList = [];

  modelRTSName: string = "";
  editingRTSName: boolean = true;
  critErrorsRTSName: boolean = false;

  modelRTSColor: string = "#ffffff";
  editingRTSColor: boolean = true;

  ///////// IVQ
  @ViewChild('inputIVQ', { static: false }) inputCtrlIVQ;
  controlIVQ = new FormControl();

  toHighlightIVQ: string = '';
  ivqNamesObservable: string[];
  ivqNames: string[] = [];
  selectedIVQNames: string[] = [];
  ivqNameDetailList = [];

  modelIVQName: string = "";
  editingIVQName: boolean = true;
  critErrorsIVQName: boolean = false;

  modelIVQColor: string = "#ffffff";
  editingIVQColor: boolean = true;

  ///////// PCM
  @ViewChild('inputPCM', { static: false }) inputCtrlPCM;
  controlPCM = new FormControl();

  toHighlightPCM: string = '';
  pcmNamesObservable: string[];
  pcmNames: string[] = [];
  selectedPCMNames: string[] = [];
  pcmNameDetailList = [];

  modelPCMName: string = "";
  editingPCMName: boolean = true;
  critErrorsPCMName: boolean = false;

  modelPCMColor: string = "#ffffff";
  editingPCMColor: boolean = true;

  ///////////////////////////////////////////end dropdown

  rtsData: RTSFileData[];
  ivqData: IVQFileData[];
  //=[
  //  {
  //    xAxis: 0,
  //    yAxis: 0,
  //    eventDate: '',
  //    iconColor: 'blue',
  //    iconType: ''
  //  },
  //]
  //@ViewChild('waveForm', { static: true }) audioRef: ElementRef;

  @ViewChild('title', { static: true }) titleRef: ElementRef<HTMLDivElement>;
  @ViewChild('fileInputImage', { static: false }) fileInputImage: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputRTS', { static: false }) fileInputRTS: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputIVQ', { static: false }) fileInputIVQ: ElementRef<HTMLInputElement>;
  @ViewChild('fileInputPCM', { static: false }) fileInputPCM: ElementRef<HTMLInputElement>;
  @ViewChild('legend', { static: false }) captureDiv: ElementRef;
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggerCollection: QueryList<MatAutocompleteTrigger>;

  //@ViewChild('waveform', { static: false }) waveform: NgWaveformComponent;

  ////////////////////////// Symbol info
  /// 30 = small triangle symbol with blue color on top rightside of square symbol
  /// -1 = small star symbol with blue color on top of rightside of square symbol
  /// 0 = only square symbol
  /// Inbound = big traingle symbol
  /// Outbound = big circle symbol
  /// pause = big traingle ontop of square and bigcirle on bottom of square and small traingle ontop rightside of square
  ///

  isDeskTop = true;

  constructor(private sanitizer: DomSanitizer, private _Activatedroute: ActivatedRoute, private windowelementRef: ElementRef, private renderer: Renderer2, private _router: Router, private http: HttpClient, private service: DemoService, public datepipe: DatePipe, private commonFilterService: CommonFilterService, private dialog: MatDialog, private cdr: ChangeDetectorRef, private responsive: BreakpointObserver) {
    this.baseUrl = environment.urlAddress + '/api/';



    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;
      this.parentEvent();
    });

    this.commonFilterService.TSType.subscribe(res => {
      this.commonFilter = new CommonFilter();
      //this.SetTimestampSearch(res);
    });//TsType


    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      if (res === 'onlyCRInit' && !this.filterEventIDSelected)
        // this.UpdateScreen();

        if (this.filterEventIDSelected)
          this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //this.UpdateScreen();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //https://stackoverflow.com/questions/57909492/does-the-subscribe-function-execute-synchronously
    //return this.commonFilterService.AllGeneralFilter.pipe(map(res => {
    //https://stackoverflow.com/questions/53741079/filter-with-json-in-angular-6
    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(res => {
      this.AllGeneralFilter = res;
      if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
        //this.UpdateScreen();

        //reset here
        if (this.delColSelected)
          this.delColSelected = false;
      if (this.clearAllFiltersBool)
        this.clearAllFiltersBool = false;

      this.delFilterColName = '';//reset if delete or clear all filters
    });
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //https://medium.com/cp-massive-programming/angular-user-inheritance-to-unsubscribe-from-observables-f5617fbbd8f2
    //https://stackoverflow.com/questions/42951400/angular-2-behaviorsubject-avoid-with-multiple-subscription
    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          this.delFilterColName = res;
          //this.UpdateScreen();
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      //console.log(res)
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0)) {
        //  this.UpdateScreen();
        //}
      });
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            //this.UpdateScreen();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

    ///// Load ITS canvas first time
    this.firstTimeFunctionCall = true;


    this.responsive.observe(['(min-width: 960px)', '(max-width: 1279.99px)', '(min-width: 1280px)', Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
      Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
      Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
      Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.Tablet] || breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
          || breakpoints[Breakpoints.Handset] || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]
          || breakpoints[Breakpoints.XSmall] || breakpoints[Breakpoints.Small]) {
          this.isDeskTop = false;
          if ((breakpoints['(min-width: 960px)'] && breakpoints['(max-width: 1279.99px)']) || breakpoints['(min-width: 1280px)']) {
            this.isDeskTop = true;
          }
        }
        else if (breakpoints[Breakpoints.Medium]) {
          this.isDeskTop = false;
        }
        else {
          this.isDeskTop = true;
        }
      });

  }

  parentEvent() {
    ////debugger;
    this.title = rsltTypeInTitle(this.rsltType);
    this.title = "ITS Viewer";
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
  }

  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  LoadExistingConfig() {
    /// Load ITS canvas

    const _itsFiles = this.commonFilterService.ITSValue.subscribe(res => {
      debugger;
      ///FirstTimecall is to check whether call is from inside the function or first time from the contructor when page loaded
      if (this.firstTimeFunctionCall) {
        this.firstTimeFunctionCall = false;
        if (res != null) {
          if (res[3] == 'Local') {
            this.isLoading = true;
            this.selectedImageFile = res[0];
            this.selectedRTSFileToUpload = res[1];
            this.selectedIVQFile = res[2];
            this.pcmFolderName = res[4];
            this.imageFileName = this.selectedImageFile.name;
            this.rtsFileName = this.selectedRTSFileToUpload.name;
            this.ivqFileName = this.selectedIVQFile.name;
            this.LoadImageInCanvas(this.selectedImageFile, true);
            this.LoadRTSInCanvas(this.selectedRTSFileToUpload, true);
            this.isLoading = false;
          }
          else {
            //this.selectedImageFile = res[0];
            this.isLoading = true;
            this.SelectedImageFileIUpload_RemoteSystem = res[0];
            this.rtsFileData_RemoteSystem = res[1];
            this.SelectedIVQFileUpload_RemoteSystem = res[2];
            this.imageFileName_RemoteSystem = res[3];
            this.SelectedImageFile_RemoteSystem = res[3].split('\\')[res[3].split('\\').length - 1];///extract only file name
            this.rtsFileName_RemoteSystem = res[4];/// rts file name along with full path
            this.SelectedRTSFile_RemoteSystem = res[4].split('\\')[res[4].split('\\').length - 1];///extract only file name
            this.ivqFileName_RemoteSystem = res[5];
            this.SelectedIVQFile_RemoteSystem = res[5].split('\\')[res[5].split('\\').length - 1];///extract only file name
            this.pcmFolderName_RemoteSystem = res[6];
            this.imageNames = res[7];
            this.rtsNames = res[8];
            this.ivqNames = res[9];
            this.modelImageName = res[10];
            this.modelRTSName = res[11];
            this.modelIVQName = res[12];
            this.selectedImageNames = [res[10]];
            this.selectedRTSNames = [res[11]];
            this.selectedIVQNames = [res[12]];

            if (res[13] != undefined) {
              this.pcmNames = res[13];
              this.modelPCMName = res[14];
              this.selectedPCMNames = [res[14]];
              this.isAudioChecked = true;
            }

            this.SetDefaultDropdownValue_RemoteSystem();

            //this.GetImageFromRemoteServerPath();
            this.LoadImageInCanvas(this.SelectedImageFileIUpload_RemoteSystem, true);
            this.FormatRTSData(this.rtsFileData_RemoteSystem, true);
            //this.ShowITSMap();
            setTimeout(() => {
              this.ShowITSMap();
            }, 1000);

            this.isLoading = false;

          }
        }
        else {
          this.GetITSFiles();
          this.GetPCMFolders();
        }
      }
    });
    this.subscriptions.push(_itsFiles);

  }

  SetDefaultDropdownValue_RemoteSystem() {

    this.imageNamesObservable = this.imageNames;
    const defaultFile = this.imageNamesObservable.find(item => item === this.modelImageName); // Set your logic here to find the default
    this.controlImage.setValue(defaultFile);

    ///// rts dropdown
    this.rtsNamesObservable = this.rtsNames;
    const defaultRTSFile = this.rtsNamesObservable.find(item => item === this.modelRTSName); // Set your logic here to find the default
    this.controlRTS.setValue(defaultRTSFile);

    ///// ivq dropdown
    this.ivqNamesObservable = this.ivqNames;
    const defaultIVQFile = this.ivqNamesObservable.find(item => item === this.modelIVQName); // Set your logic here to find the default
    this.controlIVQ.setValue(defaultIVQFile);
    if (this.modelPCMName != "") {
      ///// pcm dropdown
      this.pcmNamesObservable = this.pcmNames;
      const defaultPCMFile = this.pcmNamesObservable.find(item => item === this.modelPCMName); // Set your logic here to find the default
      this.controlPCM.setValue(defaultPCMFile);
    }
  }
  ///////////////////////////////////////////////// Start PCM to WAV

  //pcmFile: File;
  //onPCMFileChange(event) {

  //  this.pcmFile = event.target.files[0];

  //  this.ConvertPCMToWAV(event);
  //  // this.convertToWav();


  //}

  //async convertToWav() {
  //  try {
  //    // Read PCM file as ArrayBuffer
  //    const pcmArrayBuffer = await this.readFileAsArrayBuffer(this.pcmFile);

  //    // Convert PCM to WAV
  //    const wavArrayBuffer = this.convertPcmToWav(pcmArrayBuffer);

  //    // Create Blob from WAV ArrayBuffer
  //    const wavBlob = new Blob([wavArrayBuffer], { type: 'audio/wav' });

  //    ////Create download link
  //    const downloadLink = document.createElement('a');
  //    downloadLink.href = URL.createObjectURL(wavBlob);
  //    downloadLink.download = 'audio.wav';

  //    // Trigger download
  //    downloadLink.click();

  //    // Path where you want to save the WAV file
  //    // const filePath = '/Webviewer/assets/audio/audio444.wav';
  //    // saveAs(wavBlob, filePath);

  //    // Save the WAV Blob as a file

  //    // Write the WAV data to the file
  //    //fs.writeFile(filePath, Buffer.from(wavArrayBuffer), (err) => {
  //    //  if (err) {
  //    //    console.error('Error saving WAV file:', err);
  //    //    return;
  //    //  }
  //    //});

  //  } catch (error) {
  //    console.error('Error converting to WAV:', error);
  //  }
  //}

  //readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
  //  return new Promise((resolve, reject) => {
  //    const reader = new FileReader();
  //    reader.onload = () => {
  //      resolve(reader.result as ArrayBuffer);
  //    };
  //    reader.onerror = reject;
  //    reader.readAsArrayBuffer(file);
  //  });
  //}

  //convertPcmToWav(pcmData: ArrayBuffer): ArrayBuffer {
  //  // Implement PCM to WAV conversion logic here
  //  // You can find JavaScript code snippets or libraries for PCM to WAV conversion
  //  // For example, you can prepend a WAV file header to the PCM data
  //  // Return the resulting WAV ArrayBuffer

  //  ////sampleRate: number, This will be provided by customer either 8000, 16000 or 48000.
  //  ////numChannels: number, This is 1 Channel(Mono) -> fixed
  //  ////bitsPerSample: number, Signed 16 bit PCM -> fixed
  //  ////Byte Order -> Little ending -> fixed


  //  const pcmDataView = new DataView(pcmData);
  //  const numChannels = 1; // Assuming mono audio
  //  const sampleRate = 8000;//44100; // Sample rate in Hz
  //  const bitDepth = 16; // Bits per sample
  //  const dataSize = pcmData.byteLength;
  //  const dataOffset = 44; // Size of the WAV header

  //  // Create a new ArrayBuffer for the WAV data
  //  const wavData = new ArrayBuffer(dataOffset + dataSize);
  //  const wavDataView = new DataView(wavData);

  //  // Write WAV header
  //  // Chunk ID: "RIFF"
  //  this.writeString(wavDataView, 0, 'RIFF');
  //  // File size (excluding Chunk ID and Chunk Size fields)
  //  wavDataView.setUint32(4, dataSize + 36, true);
  //  // Format: "WAVE"
  //  this.writeString(wavDataView, 8, 'WAVE');
  //  // Subchunk 1 ID: "fmt "
  //  this.writeString(wavDataView, 12, 'fmt ');
  //  // Subchunk 1 size (16 for PCM)
  //  wavDataView.setUint32(16, 16, true);
  //  // Audio format (1 for PCM)
  //  wavDataView.setUint16(20, 1, true);
  //  // Number of channels
  //  wavDataView.setUint16(22, numChannels, true);
  //  // Sample rate
  //  wavDataView.setUint32(24, sampleRate, true);
  //  // Byte rate (SampleRate * NumChannels * BitsPerSample / 8)
  //  wavDataView.setUint32(28, sampleRate * numChannels * (bitDepth / 8), true);
  //  // Block align (NumChannels * BitsPerSample / 8)
  //  wavDataView.setUint16(32, numChannels * (bitDepth / 8), true);
  //  // Bits per sample
  //  wavDataView.setUint16(34, bitDepth, true);
  //  // Subchunk 2 ID: "data"
  //  this.writeString(wavDataView, 36, 'data');
  //  // Subchunk 2 size (dataSize)
  //  wavDataView.setUint32(40, dataSize, true);

  //  // Copy PCM data to WAV data
  //  const pcmDataUint8 = new Uint8Array(pcmData);
  //  const wavDataUint8 = new Uint8Array(wavData, dataOffset);
  //  wavDataUint8.set(pcmDataUint8);

  //  return wavData;
  //}

  //writeString(view: DataView, offset: number, str: string) {
  //  for (let i = 0; i < str.length; i++) {
  //    view.setUint8(offset + i, str.charCodeAt(i));
  //  }
  //}

  //togglePlayback() {
  //  this.isPlaying = !this.isPlaying;
  //  if (this.isPlaying) {
  //    // Start playback
  //    this.onAudioPlay();
  //  } else {
  //    // Pause playback
  //    this.onAudioPause();
  //  }
  //}

  //onAudioPlay() {
  //  //this.audio = new Audio('/Webviewer/assets/audio/audioTest.wav');
  //  //this.audio.play();
  //  this.waveform.play(); 
  //}

  //onAudioPause() {
  //  //this.audio.pause();
  //  this.waveform.pause();
  //}

  //onAudioStop() {
  //  //this.audio.pause();
  //  //this.audio.currentTime = 0;
  //  // Seek to the start of the audio


  //}

  ///////////////////////////////////////////////// End PCM to WAV

  ngOnInit() {

    //setTimeout(() => {
    //  this.GetITSRating();
    //}, 1000);

    this.GetITSRating();
    this.InitializeITSMap();

    //this.cdr.detectChanges();

  }

  LoadSystem(system) {
    //this.cdr.detectChanges();
    this.showITSMap = false;
    this.showRating = false;
    this.isRemoteSystem = true;
    if (system == 'Remote')
      this.isRemoteSystem = true;
    else {
      this.isRemoteSystem = false;
      this.LoadImageInCanvas(this.selectedImageFile, false);
      this.LoadRTSInCanvas(this.selectedRTSFileToUpload, false);
    }

    //this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    //this.InitializeITSMap();
    //this.showITSMap = false;

    ///this.firstTimeFunctionCall = true;
    ///to load existing config while toggling between Remote n Local switch button
    ///this.LoadExistingConfig();

  }

  InitializeITSMap() {
    this.element = <Element>this.root;
    this.canvas = <HTMLCanvasElement>document.getElementById("canvas");
    this.ctx = this.canvas.getContext("2d");
  }

  SetITSCoordinate() {
    //this.getPosition(240, 150, 90);
    //this.getPosition(185, 270, 170);
    //this.DrawCoordinatesWithTilte(223, 302, 170);//circle with title
    ////this.DrawTrianglewithImage(295, 350, 170);///triangle image
    ////this.DrawTrianglewithImage(95, 350, 170); //triangle image
    //this.DrawSquareWithColor(195, 350, 170); //square
    //this.DrawSquareWithTitle(185, 250, 170); //square with title
    //this.DrawSquareWithTitle(115, 50, 170); //square with title


    //this.DrawTriangleWith2Corodinates(335, 250, 170); //triangle
    //this.DrawTriangleWithTitle(435, 250, 170); //triangle with title
    //this.DrawTriangleWithSmalSize(200, 270, 170);//small size triangle    
    //this.DrawStartWithColor(285, 250, 170);    //star
    //this.DrawSmallStartWithTitle(100, 270, 170);//small star with title
    ////this.DrawCoordinatesWithTilte(435, 350, 170);//circle with title
    //this.DrawCoordinatesBetween2Point(50, 50, 170);
    //this.DrawMultiSymbolAtSameCordinate_Pause(550, 300, 170);

    //this.DrawMultiSymbolAtSameCordinate_SquareStar_Stop(400, 300, 170);
    //this.DrawMultiSymbolAtSameCordinate_SquareTriangle(320, 300, 170);
  }

  //////// Send PCM Filename to sever

  //ConvertPCMToWAV(event) {
  //  //debugger;
  //  let sampleRate = 8000;
  //  this.pcmFile = event.target.files[0];
  //  const formData = new FormData();
  //  formData.append('pcmFile', this.pcmFile);

  //  this.url = this.baseUrl + 'ITS/ConvertPCMToWAV';
  //  this.ConvertPCMToWav_Service(formData, sampleRate).subscribe((res: any) => {
  //    //console.log(res);
  //    let rows: any = JSON.parse(res) as any;

  //  });

  //}

  ConvertPCMToWAV(pcmFileName) {
    debugger;
    this.showPCMFileError = false;
    this.ShowPCMFileErrorMsg = ""

    let sampleRate = parseInt(this.selectedSampleRate[0]);
    pcmFileName = pcmFileName.split('\\')[3];
    let pcmFolderName = "";
    if (this.isRemoteSystem) {
      if (this.pcmFolderName_RemoteSystem.trim() == "") {
        this.showPCMFileError = true;
        this.ShowPCMFileErrorMsg = "pcm file cannot be empty."
        return false;
      }
      if (this.modelPCMName.trim() == "") {
        this.showPCMFileError = true;
        this.ShowPCMFileErrorMsg = "select pcm folder."
        return false;
      }
      pcmFolderName = this.pcmFolderName_RemoteSystem + "\\" + this.modelPCMName;
      //////check path contains drive name or ip address to add blackslash at front of the path.
      //if (this.containsDriveName(this.pcmFolderName_RemoteSystem))
      //  pcmFolderName = this.pcmFolderName_RemoteSystem;
      //else
      //  pcmFolderName = "\\" + this.pcmFolderName_RemoteSystem;
    }
    else {
      if (this.pcmFolderName.trim() == "") {
        this.showPCMFileError = true;
        this.ShowPCMFileErrorMsg = "please enter shared pcm files folder path."
        return false;
      }
      pcmFolderName = this.pcmFolderName;
    }

    this.url = this.baseUrl + 'ITS/ConvertPCMToWAV';
    debugger;
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    this.ConvertPCMToWav_Service(pcmFolderName, pcmFileName, sampleRate).subscribe((res: any) => {
      //console.log(res);
      //let rows: any = JSON.parse(res) as any;

      if (res == "success") {
        this.OpenPcmAudioDialog(res, pcmFileName);
      }
      else {
        this.OpenPcmAudioDialog(res, pcmFileName);
      }


    });

  }

  ////open audio popup to play pcm file
  OpenPcmAudioDialog(message: string, pcmFileName: string) {
    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    ////debugger;


    dailogConfig.data = { audioURL: this.audioURL, nodeName: pcmFileName, message: message };
    if (this.dialog.openDialogs.length == 0) {
      this.dialog.open(AudioPlayerPopupComponent, dailogConfig);
    }
  }

  containsDriveName(path: string): boolean {
    // Regular expression to match drive letter (e.g., C: or D:)
    const driveRegex = /^[A-Z]:\\/i;
    return driveRegex.test(path);
  }

  //////////////////////////////////////////////////////// Event
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    //console.log(event.currentTarget.window.innerWidth);
    //console.log(event.currentTarget.window.innerHeight);
    if (event.currentTarget.window.innerWidth < 1307)
      this.windowMinimized = true;
    else
      this.windowMinimized = false;

  }

  openFileBrowseDialog(InputType) {
    this.isLoading = true;
    if (InputType == "IMAGE")
      this.fileInputImage.nativeElement.click();
    else if (InputType == "RTS")
      this.fileInputRTS.nativeElement.click();
    else if (InputType == "IVQ")
      this.fileInputIVQ.nativeElement.click();
    else
      this.fileInputPCM.nativeElement.click();
  }

  CheckValidation_RemoteSystem() {
    this.showImageError = false;
    this.ShowImageErrorMsg = "";
    this.showRTSFileError = false;
    this.ShowRTSFileErrorMsg = "";
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    this.showGeneralError = false;
    this.ShowGeneralErrorMsg = "";
    debugger;
    if (this.modelImageName.trim() == "" || this.modelImageName.includes("Select")) {
      this.showImageError = true;
      this.ShowImageErrorMsg = "please select image filepath.";
      return false;
    }
    if (this.modelRTSName.trim() == "" || this.modelRTSName.includes("Select")) {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "please select RTS filepath.";
      return false;
    }
    if (this.modelIVQName.trim() == "" || this.modelIVQName.includes("Select")) {
      this.showIVQFileError = true;
      this.ShowIVQFileErrorMsg = "please select IVQ filepath.";
      return false;
    }

    //if (!this.imageFileName_RemoteSystem.startsWith("\\\\")) {
    //  this.showImageError = true;
    //  this.ShowImageErrorMsg = "filepath should always start with '\\\\'";
    //  return false;
    //}
    //if (!this.rtsFileName_RemoteSystem.startsWith("\\\\")) {
    //  this.showRTSFileError = true;
    //  this.ShowRTSFileErrorMsg = "filepath should always start with '\\\\'";
    //  return false;
    //}
    //if (!this.ivqFileName_RemoteSystem.startsWith("\\\\")) {
    //  this.showIVQFileError = true;
    //  this.ShowIVQFileErrorMsg = "filepath should always start with '\\\\'";
    //  return false;
    //}
    return true;
  }

  ////// Remote Server System
  ShowITSMap_RemoteSystem() {

    if (!this.CheckValidation_RemoteSystem())
      return;
    debugger;
    this.imageFileName_RemoteSystem = this.folderPath_RemoteSystem + "\\" + this.modelImageName;
    this.rtsFileName_RemoteSystem = this.folderPath_RemoteSystem + "\\" + this.modelRTSName;
    this.ivqFileName_RemoteSystem = this.folderPath_RemoteSystem + "\\" + this.modelIVQName;

    this.GetImageFromRemoteServerPath();

    ////if (this.modelPCMName.trim() == "") {
    ////  this.GetPCMFolders();
    ////}

  }

  onCheckboxChange(event) {
    this.isAudioChecked = (event.target as HTMLInputElement).checked;
  }

  GetITSFiles() {
    debugger;
    this.modelImageName = "";
    this.modelRTSName = "";
    this.modelIVQName = "";
    this.imageNames = [];
    this.rtsNames = [];
    this.ivqNames = [];
    this.selectedImageNames = [];
    this.selectedRTSNames = [];
    this.selectedIVQNames = [];
    this.imageNamesObservable = [];
    this.rtsNamesObservable = [];
    this.ivqNamesObservable = [];

    let folderPath = this.folderPath_RemoteSystem.replace(/\\/g, "\\\\");
    //let fileName = folderPath.split('\\')[folderPath.split('\\').length - 1]; ///extract only file name

    this.isLoading = true;
    debugger;
    this.url = this.baseUrl + 'ITS/GetITSFiles';
    this.GetITSFiles_Service(folderPath, this.isSaveITSFilePath).subscribe((res) => {
      debugger;
      const rows = JSON.parse(res);
      if (rows == 'failed') {
        this.imagePlaceholder = "No File Found";
        this.rtsPlaceholder = "No File Found";
        this.ivqPlaceholder = "No File Found";
        this.controlImage.setValue('');
        this.controlRTS.setValue('');
        this.controlIVQ.setValue('');
        this.isLoading = false;
        return false;
      }
      //console.log(rows);
      //let img = rows[0];
      this.isSaveITSFilePath = false;

      ////// fill image dropdown
      rows[0].forEach((rw, i) => {
        //console.log(rw);
        this.imageNames.push(rw);//fill reg dropdown        
      });
      //////// add default --Select-- at top of all element
      this.imageNames.unshift('--Select--');

      ////// fill RTS dropdown
      rows[1].forEach((rw, i) => {
        //console.log(rw);
        this.rtsNames.push(rw);//fill reg dropdown        
      });
      //////// add default --Select-- at top of all element
      this.rtsNames.unshift('--Select--');

      ////// fill IVQ dropdown
      rows[2].forEach((rw, i) => {
        //console.log(rw);
        this.ivqNames.push(rw);//fill reg dropdown        
      });
      //////// add default --Select-- at top of all element
      this.ivqNames.unshift('--Select--');

      this.setList(false);
      this.isLoading = false;

    });


  }

  GetImageFromRemoteServerPath() {
    //let filePath = "\\192.168.1.41\\Shared WvSQL\\officefloormap.jpg"; //// filepath should have double backslash'\\' mandatory
    //let filePath = "\\GLIN-164\\Shared WvSQL\\ITS\\ITS\\POLQA\\Industrial Style Office.jpg";
    debugger;
    let filePath = this.imageFileName_RemoteSystem.replace(/\\/g, "\\\\");
    let fileName = filePath.split('\\')[filePath.split('\\').length - 1]; ///extract only file name
    this.SelectedImageFile_RemoteSystem = fileName;
    /// filePath = "\\" + filePath;/// add backslash'\\' at front then only in server side it will consider as filepath.
    debugger;
    this.url = this.baseUrl + 'ITS/GetImageFromRemoteServerPath';
    this.GetImageFromRemoteServerPath_Service(filePath).subscribe({
      next: (response: Blob) => {
        //console.log(response);
        debugger;
        //// Create a File object from the response Blob
        //this.selectedImageFile = new File([response], fileName, { type: response.type, });
        this.SelectedImageFileIUpload_RemoteSystem = new File([response], fileName, { type: response.type, });

        //console.log('File downloaded:', this.selectedImageFile);
        ////////////////////////////////////////////////////////////////////////
        //this.imageFileName = this.selectedImageFile.name;
        //var reader = new FileReader();
        //reader.readAsDataURL(this.selectedImageFile);
        //reader.onload = (event: any) => {
        //  this.imageURL = reader.result;

        //  //var ctxt = this.canvas.getContext("2d");  ////elumalai as ctx is defined globally so no need to create new canvas object
        //  var backgroundImage = new Image();
        //  backgroundImage.src = this.imageURL;
        //  backgroundImage.onload = () => {
        //    this.canvas.width = backgroundImage.width;
        //    this.canvas.height = backgroundImage.height;

        //    this.ctx.drawImage(backgroundImage, 0, 0);

        //  };
        //  this.showITSMap = true;
        //}
        ///////////////////////////////////
        this.LoadRTSFileFromRemoteServerPath();
        //this.showITSMap = true;
      },
      error: (error) => {
        debugger;
        // Handle error: Show the error message
        this.showGeneralError = true;
        this.ShowGeneralErrorMsg = "*The network path was not found.";
      }
    });
  }

  LoadRTSFileFromRemoteServerPath() {
    //let filePath = "\\192.168.1.41\\Shared WvSQL\\officefloormap.jpg"; //// filepath should have double backslash'\\' mandatory
    let filePath = this.rtsFileName_RemoteSystem.replace(/\\/g, "\\\\");     //"\\GLIN-164\\Shared WvSQL\\ITS\\ITS\\POLQA\\Office3Dimage032120231756.rts";
    this.SelectedRTSFile_RemoteSystem = filePath.split('\\')[filePath.split('\\').length - 1];
    ///filePath = "\\" + filePath;/// add backslash'\\' at front then only in server side it will consider as filepath.
    debugger;
    this.url = this.baseUrl + 'ITS/LoadRTSFileFromRemoteServerPath';
    this.LoadRTSFileFromRemoteServerPath_Service(filePath).subscribe((res: any) => {
      debugger;
      //console.log(res);
      if (res != null) {
        let rows: any = JSON.parse(res) as any;
        this.FormatRTSData(rows);
        this.rtsFileData_RemoteSystem = rows;
        //// Create a File object from the response Blob
        //this.selectedRTSFileToUpload = new File([response], fileName, { type: response.type, });

        this.GetIVQFileFromRemoteServerPath();
      }
      else {
        this.showGeneralError = true;
        this.ShowGeneralErrorMsg = "*The network path was not found.";
      }
    });
  }

  GetIVQFileFromRemoteServerPath() {

    let filePath = this.ivqFileName_RemoteSystem.replace(/\\/g, "\\\\"); //"\\GLIN-164\\Shared WvSQL\\ITS\\ITS\\POLQA\\Office3Dimage032120231756.ivq";
    let fileName = filePath.split('\\')[filePath.split('\\').length - 1];
    this.SelectedIVQFile_RemoteSystem = fileName;
    /// filePath = "\\" + filePath; /// add backslash'\\' at front then only in server side it will consider as filepath.
    debugger;
    this.url = this.baseUrl + 'ITS/GetIVQFileFromRemoteServerPath';
    this.GetIVQFileFromRemoteServerPath_Service(filePath).subscribe({
      next: (response: Blob) => {
        // console.log(response);
        debugger;
        //// Create a File object from the response Blob
        this.SelectedIVQFileUpload_RemoteSystem = new File([response], fileName, { type: response.type, });

        this.ShowITSMap();

        ////SET ALL 3 INFO FILE IN SUBCRIPTION
        const itsFiles: any[] = [];
        itsFiles.push(this.SelectedImageFileIUpload_RemoteSystem);
        itsFiles.push(this.rtsFileData_RemoteSystem);
        itsFiles.push(this.SelectedIVQFileUpload_RemoteSystem);
        //itsFiles.push(this.selectedFilter);//not in use 
        itsFiles.push(this.imageFileName_RemoteSystem);
        itsFiles.push(this.rtsFileName_RemoteSystem);
        itsFiles.push(this.ivqFileName_RemoteSystem);
        itsFiles.push(this.pcmFolderName_RemoteSystem);

        itsFiles.push(this.imageNamesObservable);
        itsFiles.push(this.rtsNamesObservable);
        itsFiles.push(this.ivqNamesObservable);
        itsFiles.push(this.modelImageName);
        itsFiles.push(this.modelRTSName);
        itsFiles.push(this.modelIVQName);
        if (this.modelPCMName != "") {
          itsFiles.push(this.pcmNamesObservable);
          itsFiles.push(this.modelPCMName);
        }

        this.firstTimeFunctionCall = false;
        this.commonFilterService.SetITSFile(itsFiles); //store files in subcription

      },
      error: (error) => {
        debugger;
        // Handle error: Show the error message
        this.showGeneralError = true;
        this.ShowGeneralErrorMsg = "*The network path was not found.";
      }
    });
  }

  ControlFocusOut() {
    //alert();
    this.isLoading = false;
  }

  onPCMFileChange(event) {
    debugger;
    let pcmFile = "femrecNB_20230321175504_N12$55'35''_E77$36'3''_000000_I_NBSide2_IN105Test2_20230321175446_1.pcm";
    //console.log(event.target.files);
    this.selectedAllPCMFiles = Array.from(event.target.files);
    //console.log(this.selectedAllPCMFiles);

    if (this.selectedAllPCMFiles.length > 0) {
      this.fileUPPCM = this.selectedAllPCMFiles.filter(m => m.name == pcmFile)[0];//filteredpcmFile

      let sampleRate = parseInt(this.selectedSampleRate[0]);
      const formData = new FormData();
      formData.append('file', this.fileUPPCM);

      this.url = this.baseUrl + 'ITS/ConvertPCMFile';
      this.SendPCMFile_Service(formData, sampleRate).subscribe((res: any) => {
        //console.log(res);
        if (res != "InvalidFile") {
          let rows: any = JSON.parse(res) as any;
          ////debugger;
          //console.log(rows);

        }
      });


    }
  }

  onImageFileChange(event) {
    ////debugger;

    this.isLoading = false;
    if (event.target.files.length <= 0) {

      return false;
    }

    this.showITSMap = false;
    this.showRating = false;
    this.showImageError = false;
    this.ShowImageErrorMsg = "";
    this.titleRef.nativeElement.style.display = 'none';
    this.ivqData = [];

    this.selectedImageFile = event.target.files[0];
    this.LoadImageInCanvas(this.selectedImageFile);
    //this.imageFileName = this.selectedImageFile.name;
    //var reader = new FileReader();
    //reader.readAsDataURL(this.selectedImageFile);
    //reader.onload = (event: any) => {
    //  this.imageURL = reader.result;

    //  var ctxt = this.canvas.getContext("2d");
    //  var backgroundImage = new Image();
    //  backgroundImage.src = this.imageURL;
    //  backgroundImage.onload = () => {
    //    this.canvas.width = backgroundImage.width;
    //    this.canvas.height = backgroundImage.height;
    //    ctxt.drawImage(backgroundImage, 0, 0);

    //    this.ngOnInit();
    //  };

    //}

  }

  LoadImageInCanvas(selectedImageFile, isPageload = false) {
    debugger;
    if (selectedImageFile != null) {
      if (!this.isRemoteSystem)
        this.imageFileName = selectedImageFile.name;
      var reader = new FileReader();
      reader.readAsDataURL(selectedImageFile);
      reader.onload = (event: any) => {
        this.imageURL = reader.result;

        //var ctxt = this.canvas.getContext("2d");  ////elumalai as ctx is defined globally so no need to create new canvas object
        var backgroundImage = new Image();
        backgroundImage.src = this.imageURL;
        backgroundImage.onload = () => {
          this.canvas.width = backgroundImage.width;
          this.canvas.height = backgroundImage.height;
          // ctxt.drawImage(backgroundImage, 0, 0);  //elumalai

          this.ctx.drawImage(backgroundImage, 0, 0);

          //////this.ngOnInit();
          ////// if (!isPageload)
          // this.InitializeITSMap();///elumalai 13/07/2023
        };

      }
    }
  }

  onRTSFileChange(event) {
    ////debugger;
    this.isLoading = false;
    if (event.target.files.length <= 0) {
      return false;
    }
    this.showITSMap = false;
    this.showRating = false;
    this.showRTSFileError = false;
    this.ShowRTSFileErrorMsg = "";
    this.titleRef.nativeElement.style.display = 'none';
    this.selectedRTSFileToUpload = event.target.files[0]; //files;
    this.LoadRTSInCanvas(this.selectedRTSFileToUpload);

    //this.rtsFileName = this.selectedRTSFileToUpload.name;

    //if (this.selectedRTSFileToUpload.name.split('.')[1] != "rts") {
    //  //this.selectedRTSFileToUpload = null
    //  this.showRTSFileError = true;
    //  this.ShowRTSFileErrorMsg = "Invalid image format";
    //  return false;
    //}

    //const formData = new FormData();
    //formData.append('file', this.selectedRTSFileToUpload);

    //this.url = this.baseUrl + 'ITS/ITSRTSCheck';
    //this.GetRTSData_Service(formData).subscribe((res: any) => {
    //  //console.log(res);
    //  if (res != "InvalidFile") {
    //    let rows: any = JSON.parse(res) as any;
    //    ////debugger;
    //    //console.log(rows);
    //    this.FormatRTSData(rows);        
    //  }
    //});
  }

  LoadRTSInCanvas(selectedRTSFile, isPageLoad = false) {

    if (selectedRTSFile.name.split('.')[1] != "rts") {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "Invalid image format";
      return false;
    }
    this.rtsFileName = this.selectedRTSFileToUpload.name;
    const formData = new FormData();
    formData.append('file', selectedRTSFile);

    this.url = this.baseUrl + 'ITS/ITSRTSCheck';
    this.GetRTSData_Service(formData).subscribe((res: any) => {
      //console.log(res);
      if (res != "InvalidFile") {
        let rows: any = JSON.parse(res) as any;
        ////debugger;
        //console.log(rows);
        this.FormatRTSData(rows, isPageLoad);

        ////// below function will only be called when called from subscription
        if (isPageLoad) {
          this.ShowITSMap(true);
        }


      }
    });

  }

  CheckValidation(IVQDataList, ivqFileName) {
    ////debugger;
    this.showImageError = false;
    this.ShowImageErrorMsg = "";
    this.showRTSFileError = false;
    this.ShowRTSFileErrorMsg = "";
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    ////debugger;
    if (IVQDataList == undefined || IVQDataList.length == 0) {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "IVQ file is empty.";
      return false;
    }
    if (!this.isRemoteSystem && this.selectedImageFile == undefined) {
      this.showImageError = true;
      this.ShowImageErrorMsg = "please select RTS image.";
      return false;
    }
    if (this.rtsData == undefined || this.rtsData.length == 0) {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "RTS file is empty.";
      return false;
    }
    if (!this.isRemoteSystem && this.selectedImageFile.name.toLowerCase() != IVQDataList[0].split('=')[1].replace("\r", "").toLowerCase()) {
      this.showImageError = true;
      this.ShowImageErrorMsg = "Please select correct Image file as mentioned in IVQ file(" + ivqFileName + ")."
      return false;
    }
    if (this.isRemoteSystem && this.SelectedImageFileIUpload_RemoteSystem.name.toLowerCase() != IVQDataList[0].split('=')[1].replace("\r", "").toLowerCase()) {
      this.showImageError = true;
      this.ShowImageErrorMsg = "Please select correct Image file as mentioned in IVQ file(" + ivqFileName + ")."
      return false;
    }

    if (!this.isRemoteSystem && this.selectedRTSFileToUpload.name.toLowerCase() != IVQDataList[1].split('=')[1].replace("\r", "").toLowerCase()) {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "Please select correct (RTS) file as mentioned in IVQ file(" + ivqFileName + ")."
      return false;
    }

    if (this.isRemoteSystem && this.SelectedRTSFile_RemoteSystem.toLowerCase() != IVQDataList[1].split('=')[1].replace("\r", "").toLowerCase()) {
      this.showRTSFileError = true;
      this.ShowRTSFileErrorMsg = "Please select correct (RTS) file as mentioned in IVQ file(" + ivqFileName + ")."
      return false;
    }


    return true;
  }

  onIVQFileChange(event) {
    ////debugger;
    this.isLoading = false;
    if (event.target.files.length <= 0) {
      return false;
    }
    this.showRating = false;
    this.showITSMap = false;
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    this.titleRef.nativeElement.style.display = 'none';

    const file: File = event.target.files[0];
    this.ivqFileName = file.name;

    if (file.name.split('.')[1] != "ivq") {
      this.showIVQFileError = true;
      this.ShowIVQFileErrorMsg = "Invalid image format";
      return false;
    }
    else
      this.selectedIVQFile = file;

    ////set all 3 file in subcription

    const itsFiles: any[] = []; //File[] = [];
    itsFiles.push(this.selectedImageFile);
    itsFiles.push(this.selectedRTSFileToUpload);
    itsFiles.push(this.selectedIVQFile);
    itsFiles.push(this.selectedFilter);
    itsFiles.push(this.pcmFolderName);
    this.firstTimeFunctionCall = false;
    this.commonFilterService.SetITSFile(itsFiles); //store 3 files in subcription

    //const itsFilesTest: File = this.selectedImageFile;
    // Convert the file to a string representation
    //const fileString = JSON.stringify(itsFiles);

    //// Save the file string in the local storage
    //localStorage.setItem('fileData', fileString);

  }


  ////// Format IVQ file data
  FormatIVQData(ivqdataList) {
    //debugger;
    this.ivqData = [];
    let ivqItems: IVQFileData;
    let rsType = ivqdataList[3].split(';')[1] != "N/A" ? "POLQA" : "PESQ";
    this.resultType = rsType;
    for (let i = 3; i < ivqdataList.length - 1; i++) {
      //console.log(i);
      ivqItems = new IVQFileData();
      let item = ivqdataList[i].split(';');
      ivqItems.score = item[1] != "N/A" ? item[1] : item[3];
      ivqItems.rating = item[15];
      ivqItems.xAxis = item[17].split(',')[0].split('&')[0];
      ivqItems.yAxis = item[17].split(',')[0].split('&')[1];
      ivqItems.eventDate = item[16];
      ivqItems.inoutbound = item[18].includes("I_") ? "I" : "O";
      ivqItems.pcmFileName = item[11];//// PCM file name

      //ivqItems.iconType = parseInt(item[3]).toString();
      this.daqScoreResult = "Fail";
      if (this.selectedTab == "DAQ" && this.filteredDAQPesqScore != undefined) {
        ////debugger;
        if (Number(ivqItems.score) >= Number(this.filteredDAQPesqScore.pesqScoreRange.split('-')[0])) {
          ivqItems.iconColor = this.modelPinColorPass; //"green";//Pass
          this.daqScoreResult = "Pass";
          ivqItems.daqScoreResult = "Pass";
        }
        else {
          ivqItems.iconColor = this.modelPinColorFail;//"red"; //Fail
          this.daqScoreResult = "Fail";
          ivqItems.daqScoreResult = "Fail";
        }

      }
      else
        ivqItems.iconColor = item[1] != "N/A" ? this.GetColorBasedOnScore(item[1]) : this.GetColorBasedOnScore(item[3]);


      this.ivqData.push(ivqItems);
    }
    //debugger;
    /////////// filter out  ivq file data based on rts file data
    for (let i = 0; i < this.rtsData.length; i++) {

      let ivqFilteredData = this.ivqData.filter(m => m.xAxis.includes(this.rtsData[i].xAxis) && m.yAxis.includes(this.rtsData[i].yAxis));
      //console.log(ivqFilteredData);
      //// to sort data as per datetime
      ivqFilteredData.sort((a, b) => Date.parse(a.eventDate) - Date.parse(b.eventDate));

      if (this.rtsData[i].iconType == "0") {
        if (this.rtsData[i + 1] != undefined)
          this.DrawMultiSymolBetween2CoordinatePoint(this.rtsData[i].xAxis, this.rtsData[i].yAxis, this.rtsData[i + 1].xAxis, this.rtsData[i + 1].yAxis, ivqFilteredData, rsType);
        else {
          //////if end point coordinate is not avaible  in ivq file then plot the excluded points
          //for (let j = 0; j < ivqFilteredData.length; j++) {
          //  if (ivqFilteredData[j].inoutbound == "O")//outbound
          //    this.DrawCoordinatesWithTilte(this.rtsData[i].xAxis + 15, this.rtsData[i].yAxis + 15, ivqFilteredData[j].iconColor, rsType, ivqFilteredData[j].eventDate, ivqFilteredData[j].score);
          //  else///Inbound
          //    this.DrawTriangleWithTitle(this.rtsData[i].xAxis + 30, this.rtsData[i].yAxis - 15, ivqFilteredData[j].iconColor, rsType, ivqFilteredData[j].eventDate, ivqFilteredData[j].score);
          //}
        }
      }
      else if (this.rtsData[i].iconType != "0" && this.rtsData[i].iconType != "-1") {
        this.DrawMultiSymbolAtSameCordinate_PauseTimer(this.rtsData[i].xAxis, this.rtsData[i].yAxis, 'blue', ivqFilteredData, rsType);
      }
      else if (this.rtsData[i].iconType == "-1") {
        // already plotter in rts section
      }

      ////debugger;
      //console.log(ivqFilteredData);
    }

    this.DrawITSMap(this.rtsData);/// this function is called again to show rts pin on top of ivq pins
    //if (this.ivqData.length > 0)
    //this.DrawITSMap(this.ivqData);
  }

  GetColorBasedOnScore(score) {

    let color = "red";


    //// DAQ tab is selected or not
    this.daqScoreResult = "Fail";
    if (this.selectedTab == "DAQ" && this.filteredDAQPesqScore != undefined) {
      ////debugger;
      if (Number(score) >= Number(this.filteredDAQPesqScore.pesqScoreRange.split('-')[0])) {
        color = this.modelPinColorPass;//"green"; GREEN
        this.daqScoreResult = "Pass";
      }
      else {
        color = this.modelPinColorFail;//"red"; FAIL
        this.daqScoreResult = "Fail";
      }

    }
    else if (this.selectedTab == "DAQ" && this.filteredDAQPesqScore == undefined) {
      color = this.modelPinColorFail;//"red"; FAIL
      this.daqScoreResult = "Fail";
    }
    else {

      if (score >= this.excellentScore)
        color = this.modelPinColorExcellent;
      else if (score >= this.goodScrore && score < this.excellentScore)
        color = this.modelPinColorGood;
      else if (score >= this.fairScore && score < this.goodScrore)
        color = this.modelPinColorFair;
      else
        color = this.modelPinColorPoor;
    }
    return color;
  }

  ////// Format RTS file data
  FormatRTSData(rtsdataList, isPageLoad = false) {
    //RTSFileData
    this.rtsData = [];
    let rtsItems: RTSFileData;
    for (let i = 0; i < rtsdataList.length; i++) {
      rtsItems = new RTSFileData();
      let item = rtsdataList[i].split(',');
      rtsItems.xAxis = Number(item[0]);
      rtsItems.yAxis = Number(item[1]);
      rtsItems.eventDate = item[2];
      rtsItems.iconType = parseInt(item[3]).toString();
      rtsItems.iconColor = 'blue';

      this.rtsData.push(rtsItems);
    }

    if (this.rtsData.length > 0) {
      debugger
      //this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ///below condition is to avoid overwriting of marker i.e if 2 or more rts and ivq files are there to plot on same jpg image
      ///then we need to clear the previous marks from jpg file in canvas
      if (!this.isRemoteSystem && this.selectedImageFile != null && !isPageLoad) {
        //this.canvas.width = this.canvas.clientWidth;
        //this.canvas.height = this.canvas.clientHeight;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.LoadImageInCanvas(this.selectedImageFile);  ///Need to check when coming back from other screen previous markers should be retain
      }
      if (this.isRemoteSystem && this.SelectedImageFileIUpload_RemoteSystem != null && !isPageLoad) {
        //this.canvas.width = this.canvas.clientWidth;
        //this.canvas.height = this.canvas.clientHeight;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.LoadImageInCanvas(this.SelectedImageFileIUpload_RemoteSystem);  ///Need to check when coming back from other screen previous markers should be retain
      }

      this.DrawITSMap(this.rtsData);

    }
  }

  DrawITSMap(data: any) {
    ////debugger;
    let symbol = "SQUARE";
    let title = "";
    for (let i = 0; i < data.length; i++) {
      switch (data[i].iconType) {
        case "0":
          symbol = "SQUARE";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          this.DrawSquareWithTitle(data[i].xAxis, data[i].yAxis, 'Red', i + 1, title, "", data[i].xAxis, data[i].yAxis);
          break;
        case "30":
          symbol = "SQUARE_WITH_SMALLTRIANGLE";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          this.DrawMultiSymbolAtSameCordinate_SquareTriangle(data[i].xAxis, data[i].yAxis, 'blue', i + 1, title, data[i].iconType);
          break;
        case "-1":
          symbol = "SQUARE_WITH_SMALLSTAR";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          this.DrawMultiSymbolAtSameCordinate_SquareStar_Stop(data[i].xAxis, data[i].yAxis, 'blue', i + 1, title);
          break;
        case "I"://inbound
          symbol = "TRIANGLE";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          //this.DrawTriangleWithTitle(data[i].xAxis, data[i].yAxis, 'blue');
          break;
        case "O"://outbound
          symbol = "CIRCLE";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          //this.DrawCoordinatesWithTilte(data[i].xAxis, data[i].yAxis, 'blue');
          break;
        case "PAUSE"://outbound
          symbol = "TRAINGLE_SQUARE_CIRCLE_SMALLTRIANGLE";
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          this.DrawMultiSymbolAtSameCordinate_Pause(data[i].xAxis, data[i].yAxis, 'blue');
          break;
        default:
          symbol = "SQUARE_WITH_SMALLTRIANGLE"; /// time other than 0 and-1 i.e 30,100,
          title = data[i].eventDate;//this.rtsData[i].eventDate;
          this.DrawMultiSymbolAtSameCordinate_SquareTriangle(data[i].xAxis, data[i].yAxis, 'blue', i + 1, title, data[i].iconType);
          break;

      }
    }

  }

  ClearAll() {
    this.showITSMap = false;
    this.showImageError = false;
    this.ShowImageErrorMsg = "";
    this.showRTSFileError = false;
    this.ShowRTSFileErrorMsg = "";
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    this.showRating = false;
    this.imageFileName = "";
    this.rtsFileName = "";
    this.ivqFileName = "";
    this.imageFileName_RemoteSystem = "";
    this.rtsFileName_RemoteSystem = "";
    this.ivqFileName_RemoteSystem = "";
    this.pcmFolderName_RemoteSystem = "";
    this.pcmFolderName = "";

    this.fileUPImage = null;
    this.fileUPRTS = null
    this.fileUPIVQ = null;
    this.selectedIVQFile = null;
    this.selectedRTSFileToUpload = null;
    this.selectedImageFile = null;
    this.SelectedIVQFileUpload_RemoteSystem = null;
    this.ivqData = [];

    this.commonFilterService.SetITSFile(null); //store 3 files in subcription
    ////debugger;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  ClearAllServerSystem() {

    this.showITSMap = false;
    this.showRating = false;

    this.showImageError = false;
    this.ShowImageErrorMsg = "";
    this.showRTSFileError = false;
    this.ShowRTSFileErrorMsg = "";
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    this.showPCMFileError = false;
    this.ShowPCMFileErrorMsg = "";

    this.imageFileName_RemoteSystem = "";
    this.rtsFileName_RemoteSystem = "";
    this.ivqFileName_RemoteSystem = "";
    ///this.pcmFolderName_RemoteSystem = "";
    this.isAudioChecked = false;
    this.setList(false);
    this.setList(true);

    this.ivqData = [];
    this.commonFilterService.SetITSFile(null); //store 3 files in subcription
    ////debugger;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  ShowITSMap(isPageLoad = false) {
    debugger;
    this.showITSMap = false;
    this.showIVQFileError = false;
    this.ShowIVQFileErrorMsg = "";
    this.showPCMFileError = false;
    this.ShowPCMFileErrorMsg = "";

    if (!this.isRemoteSystem && (this.selectedIVQFile == undefined || this.selectedIVQFile == null)) {
      this.showIVQFileError = true;
      this.ShowIVQFileErrorMsg = "Please select files.";
      return false;
    }
    const file: File = this.isRemoteSystem == false ? this.selectedIVQFile : this.SelectedIVQFileUpload_RemoteSystem; //event.target.files[0];
    const reader = new FileReader();

    if (file.name.split('.')[1] != "ivq") {
      this.showIVQFileError = true;
      this.ShowIVQFileErrorMsg = "Invalid image format";
      return false;
    }
    //if (!this.isRemoteSystem && this.pcmFolderName == "") {
    //  this.showPCMFileError = true;
    //  this.ShowPCMFileErrorMsg = "please enter pcm files folder path";
    //  return false;
    //}
    if (this.isRemoteSystem && this.pcmFolderName_RemoteSystem == "") {
      this.showPCMFileError = true;
      this.ShowPCMFileErrorMsg = "please enter pcm files folder path";
      return false;
    }
    if (!this.isRemoteSystem)
      this.ivqFileName = file.name;

    reader.readAsText(file);
    reader.onload = () => {
      const IVQDataList = reader.result.toString().split('\n');
      //console.log(lines);
      if (this.CheckValidation(IVQDataList, file.name)) {
        this.FormatIVQData(IVQDataList);
        this.showITSMap = true;
        this.showRating = true;

        ////debugger;

      }
    };

  }

  GetITSRating() {

    this.url = this.baseUrl + 'ITS/GetITSRating';
    this.GetITSRating_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any = JSON.parse(res) as any;
      debugger;
      if (rows.length > 0) {
        this.modelPinColorExcellent = rows[0].Color.split('@')[0];
        this.modelPinColorGood = rows[0].Color.split('@')[1];
        this.modelPinColorFair = rows[0].Color.split('@')[2];
        this.modelPinColorPoor = rows[0].Color.split('@')[3];

        this.excellentScore = rows[0].Rating.split('@')[0];
        this.goodScrore = rows[0].Rating.split('@')[1];
        this.fairScore = rows[0].Rating.split('@')[2];
        this.poorScore = rows[0].Rating.split('@')[3];
        //console.log(rows[0].DAQ.split('@')[0]);
        this.daqScore = Number(rows[0].DAQ.split('@')[0]);
        this.modelPinColorPass = rows[0].DAQ.split('@')[1];
        this.modelPinColorFail = rows[0].DAQ.split('@')[2];

        if (rows[0].ITSFilePath != null || rows[0].ITSFilePath == '')
          this.folderPath_RemoteSystem = rows[0].ITSFilePath;
        if (rows[0].PCMFolderPath != null || rows[0].PCMFolderPath == '')
          this.pcmFolderName_RemoteSystem = rows[0].PCMFolderPath;

        ///to load existing config after returning from  another page
        this.LoadExistingConfig();

      }

    });

  }

  SaveITSRating() {

    let color = this.modelPinColorExcellent + "@" + this.modelPinColorGood + "@" + this.modelPinColorFair + "@" + this.modelPinColorPoor;
    let rating = this.excellentScore + "@" + this.goodScrore + "@" + this.fairScore + "@" + this.poorScore;
    let daqData = this.daqScore + "@" + this.modelPinColorPass + "@" + this.modelPinColorFail;
    const params = {
      Rating: rating,
      Color: color,
      DAQ: daqData
    };

    this.url = this.baseUrl + 'ITS/SaveITSRating';
    this.SaveITSRating_Service(params).subscribe((res: any) => {
      //console.log(res);
      let rows: any = JSON.parse(res) as any;

    });
  }

  ApplyScore() {
    //this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    //this.InitializeITSMap();
    //this.LoadImageInCanvas(this.selectedImageFile); /// add set timeout function to load image
    if (this.CheckColorRatingValidation()) {
      this.ShowITSMap();
      this.SaveITSRating();
    }
  }


  CheckColorRatingValidation() {
    this.colorRatingError = "";
    if (this.excellentScore <= this.goodScrore || this.excellentScore <= this.fairScore || this.excellentScore <= this.poorScore) {
      this.colorRatingError = "excellent score should be greater than good,fair and poor."
      return false;
    }
    if (this.goodScrore >= this.excellentScore || this.goodScrore <= this.fairScore || this.goodScrore <= this.poorScore) {
      this.colorRatingError = "good score should be greater than fair and poor and less than excellent score."
      return false;
    }
    if (this.fairScore >= this.excellentScore || this.fairScore >= this.goodScrore || this.fairScore <= this.poorScore) {
      this.colorRatingError = "fair score should be less than excellent, good and greater than poor."
      return false;
    }
    if (this.poorScore >= this.excellentScore || this.poorScore >= this.goodScrore || this.poorScore >= this.fairScore) {
      this.colorRatingError = "poor score should be greater than execllent,good,fair. "
      return false;
    }

    return true;
  }

  ApplyColor() {

    // Clear the canvas
    //this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    //this.InitializeITSMap();
    //this.LoadImageInCanvas(this.selectedImageFile); /// add set timeout function to load image

    this.ShowITSMap();
    this.SaveITSRating();

  }

  ApplyDAQ() {
    //debugger;
    ////const roundedNum1 = Number(num1.toFixed(1)); // Output: from 2.15 to 2.1 or 2.16 to 2.2
    this.filteredDAQPesqScore = this.DAQScoreTable.filter(m => m.daq == Number(this.daqScore.toFixed(1)))[0];

    this.ShowITSMap();
    this.SaveITSRating();
  }

  // Methods to handle tab toggling
  selectTab(index): void {
    this.showVQT = false;
    this.selectedTab = index;
    if (this.selectedTab != "DAQ") {
      this.showVQT = true;
      this.ShowITSMap();
    }
    else {
      this.ApplyDAQ();
    }




  }

  status1: boolean = true;
  status2: boolean = false;
  togglePanes(type) {
    //this.leftPanel = true;
    if (type == 1) {
      this.showLeftPanel = !this.showLeftPanel;
      this.status1 = !this.status1;
      this.status2 = false;
    }
    else if (type == 2) {
      this.status2 = !this.status2;
      this.status1 = false;
    }
  }

  downloadCanvas1() {
    // get canvas data  
    var image = this.canvas.toDataURL();
    //console.log(this.selectedImageFile);
    // create temporary link  
    var tmpLink = document.createElement('a');
    tmpLink.download = this.selectedImageFile.name; //  'image.jpg'; // set the name of the download file 
    tmpLink.href = image;

    // temporarily add link to body and initiate the download  
    document.body.appendChild(tmpLink);
    tmpLink.click();
    document.body.removeChild(tmpLink);
  }

  downloadCanvas() {
    ////debugger;
    let fileNameSaveas = this.ivqFileName.split('.')[0] + ".jpg"; //this.selectedImageFile.name.toString();
    const fileNamePanelElement = document.getElementById('hidFilePanel');
    const hidDownlaodVQTElement = document.getElementById('hidDownlaodVQT');
    const hidDownlaodDAQElement = document.getElementById('hidDownlaodDAQ');
    const divColorPanelElement = document.getElementById('hidColorPanel');
    const divElementDownload = document.getElementById('download');
    const divElementhidHelp = document.getElementById('hidHelp');

    // Make the div visible by removing the 'display' property
    this.renderer.setStyle(divColorPanelElement, 'display', '');
    this.renderer.setStyle(divElementDownload, 'display', 'none');
    this.renderer.setStyle(fileNamePanelElement, 'display', 'none');
    this.renderer.setStyle(divElementhidHelp, 'display', 'none');


    if (this.selectedTab == "VQT") {
      this.renderer.setStyle(hidDownlaodVQTElement, 'display', 'block');
      this.renderer.setStyle(hidDownlaodDAQElement, 'display', 'none');
    }
    else {
      this.renderer.setStyle(hidDownlaodVQTElement, 'display', 'none');
      this.renderer.setStyle(hidDownlaodDAQElement, 'display', 'block');
    }

    var container = document.getElementById("mainDiv"); /* full page */

    // Get the dimensions of the div
    const width = container.offsetWidth;
    const height = container.offsetHeight;

    // Get the current scroll position
    const scrollX = container.scrollWidth;
    const scrollY = container.scrollHeight;

    setTimeout(() => {
      //container.setAttribute("style", "width: 1200px; height: 1200 px;");

    }, 1000)
    //container.setAttribute("style", "width: " + scrollX + "px; height: " + scrollY+"px;");

    //window.scrollTo(0, 0);


    //https://www.studentstutorial.com/javascript/convert-html-div-element
    //https://codepedia.info/convert-html-to-image-in-jquery-div-or-table-to-jpg-png

    html2canvas(container, { allowTaint: true, width: container.scrollWidth, height: container.scrollHeight + 100, }).then(function (canvas) {

      // Restore the 'display' property back to 'none'
      // this.renderer.setStyle(divElement, 'display', 'none');
      //canvas.Width = 1500;
      //canvas.Height = 800;

      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = fileNameSaveas;//"html_image.jpg";
      link.href = canvas.toDataURL();
      link.target = '_blank';
      link.click();

    });
    // Restore the original scroll position
    //container.setAttribute("style", "width: " + width + "px; height: " + height + "px;");

    //https://stackoverflow.com/questions/20605269/screenshot-of-hidden-div-using-html2canvas
    // Restore the 'display' property back to 'none'
    this.renderer.setStyle(divColorPanelElement, 'display', 'none');
    this.renderer.setStyle(divElementDownload, 'display', 'block');
    this.renderer.setStyle(hidDownlaodVQTElement, 'display', 'none');
    this.renderer.setStyle(hidDownlaodDAQElement, 'display', 'none');
    this.renderer.setStyle(fileNamePanelElement, 'display', 'block');
    this.renderer.setStyle(divElementhidHelp, 'display', 'block');

  }

  pdfFilePathNew = "/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20";//http://localhost:4200/assets/images/ITS/ITSHelp.pdf?v=6.4.20

  OpenHelp() {

    let pdfFilePath = '/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20';
    //https://stackoverflow.com/questions/40647182/how-to-open-a-browser-window-at-25-of-its-default-size
    //https://stackoverflow.com/questions/10297168/how-to-open-maximized-window-with-javascript
    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>ITS Configuration and Operation Help</title>
						
            <body onload=""><iframe src="${pdfFilePath}" width="100%" height="100%"></iframe></body>
          </head>
        </html>
      `)
    popupWindow.document.close();

   
    // Write the HTML content to the popup window
    //    popupWindow.document.write(`
    //  <html>
    //    <body>
    //      <iframe src="${pdfFilePath}" width="600" height="400"></iframe>      
    //    </body>
    //  </html>
    //`);

    //    // Make sure to close the document write operation
    //    popupWindow.document.close();

  }

  //////////////////////////////////////////////////////////////////AUTOCOMPLETE DROPDOWN

  displayFn(selectItem: SelectItem): string {
    return '';//selectItem && selectItem.name && !selectItem.name.includes('--Select--') ? selectItem.name : '';
  }

  EditFilePath(filepathType) {
    if (filepathType == "itsFilepath") {
      this.isSaveITSFilePath = true;
    }
    else {
      this.isPCMFolderPath = true;
    }
  }

  GetPCMFolders() {
    debugger;

    this.isLoading = true;
    this.modelPCMName = "";
    this.pcmNames = [];
    this.selectedPCMNames = [];

    let folderPath = this.pcmFolderName_RemoteSystem.replace(/\\/g, "\\\\");
    //let fileName = folderPath.split('\\')[folderPath.split('\\').length - 1]; ///extract only file name

    debugger;
    this.url = this.baseUrl + 'ITS/GetPCMFolderList';
   
    this.GetITSFiles_Service(folderPath, this.isPCMFolderPath).subscribe((res) => {
        debugger;
        //console.log(res);
        //console.log('res');
        const rows = JSON.parse(res);
        if (rows == 'failed') {
          this.pcmPlaceholder = "No File Found";
          this.controlPCM.setValue('');
          this.isLoading = false;
          return false;
        }

        this.isPCMFolderPath = false;
        ////// fill pcmfolder dropdown
        rows.forEach((rw, i) => {
          //console.log(rw);
          this.pcmNames.push(rw);//fill reg dropdown        
        });
        //////// add default --Select-- at top of all element
        this.pcmNames.unshift('--Select--');

        this.setList(true);
        this.isLoading = false;
    },
      (error) => {
        this.isLoading = false;
        // Handle the error here
        console.error("Error in component:", error.message);
      });
   

  }

  setList(isPCMFolder: boolean) {

    let defaultValue = "--Select--";
    if (!isPCMFolder) {
      /// image dropdown
      this.imageNamesObservable = this.imageNames;
      const defaultFile = this.imageNamesObservable.find(item => item === defaultValue); // Set your logic here to find the default
      this.controlImage.setValue(defaultFile);

      ///// rts dropdown
      this.rtsNamesObservable = this.rtsNames;
      const defaultRTSFile = this.rtsNamesObservable.find(item => item === defaultValue); // Set your logic here to find the default
      this.controlRTS.setValue(defaultRTSFile);

      ///// ivq dropdown
      this.ivqNamesObservable = this.ivqNames;
      const defaultIVQFile = this.ivqNamesObservable.find(item => item === defaultValue); // Set your logic here to find the default
      this.controlIVQ.setValue(defaultIVQFile);
    }
    else {
      ///// pcm dropdown
      this.pcmNamesObservable = this.pcmNames;
      const defaultPCMFile = this.pcmNamesObservable.find(item => item === defaultValue); // Set your logic here to find the default
      this.controlPCM.setValue(defaultPCMFile);
    }

    this.cdr.detectChanges();
  }

  ///////////////////////////// Image Dropdown
  inputLengthImage = 0;
  setLimitedOptionsImage = true;
  openOrCloseImage = false;

  onKeydownImage($event) {
    if (!this.setLimitedOptionsImage) {
      this.setLimitedOptionsImage = true;
      this.controlImage.valueChanges.subscribe(newValue => {
        //this.regConfigNamesObservable = this._regName(newValue);
        this.imageNamesObservable = this._imageNameOnKeyDown(newValue);
      })
    }

    this.inputLengthImage = $event.target.value.length;
    //this.modelRegConfigName = $event.target.value;
    this.modelImageName = $event.target.value;
    if (this.inputLengthImage == 0) {
      this.controlImage.setValue("");
      //let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedRegNames[0]);
      //if (firstSelectedOption) {
      //  this.RegConfigClose_Region = true;
      //  this.controlRegion.setValue("");
      //  firstSelectedOption.deselect();
      //}
      this.autocompleteTriggerCollection.forEach((x, i) => {
        if (i == 0) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedImageNames[0]);
          if (firstSelectedOption) {
            this.openOrCloseImage = true;
            this.controlImage.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });

    }
  }

  _imageNameOnKeyDown(value: any): string[] {
    let imageNameValue = '';
    if (typeof value === "string") {
      this.toHighlightImage = value;
      imageNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightImage = value.name;
      imageNameValue = value.name.toLowerCase();
    }
    return this.imageNames.filter(option => option.toLowerCase().includes(imageNameValue) || option.includes('--Select--'));
  }

  OpenAutoCompeleteDailogImage(init?, closed?) {
    debugger;
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsImage = false;
      this.imageNamesObservable = this.imageNames;
    }

    this.autocompleteTriggerCollection.forEach((x, i) => {
      if (i == 0) {
        if (this.openOrCloseImage == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseImage = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrlImage.nativeElement.blur();
            this.inputCtrlImage.nativeElement.focus();
            this.toHighlightImage = this.inputCtrlImage.nativeElement.value;
            //debugger
            if (this.inputLengthImage > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedImageNames.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedImageNames[0]);
                if (firstSelectedOption) {
                  if (this.initArrowImage)
                    this.openOrCloseImage = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrCloseImage = true;
        }
      }
    });


  }

  initArrowImage = true;
  SetArrowClickImage() {
    if (this.initArrowImage) {
      this.initArrowImage = false;
    }
  }

  async onImageNameChange(event) {
    debugger;
    if (event !== undefined && event !== null) {

      this.setLimitedOptionsImage = true;
      this.imageNamesObservable = this.imageNames;

      let selID = event;// parseInt(event);
      this.selectedImageNames = [selID];
      this.modelImageName = this.imageNames.find(item => item == selID.toString()).toString();
      //this.inputLengthRegion = this.modelRegName.length;

      /////////below code is to set default fisrt value of region names in inputbox for autocomplete when config region is selected
      //if (this.regNames.length > 0) {
      //  const defaultValue = this.regionNamesObservable.find(item => item.id === selID); // Set your logic here to find the default
      //  this.controlRegion.setValue(defaultValue);
      //}

    }
    else {
      this.resetImage(null);
    }

  }

  resetImage(event) {
    if (event == null) {
      //Reset reg name and list to default
      this.selectedImageNames = [];
      this.modelImageName = "";
      this.modelImageColor = "#ffffff";//reset default color of reg

      //this.selRegionUnderCurrConfig = [];
    }
  }

  ////////////////////////////RTS Dropdown
  inputLengthRTS = 0;
  setLimitedOptionsRTS = true;
  openOrCloseRTS = false;

  onKeydownRTS($event) {
    if (!this.setLimitedOptionsRTS) {
      this.setLimitedOptionsRTS = true;
      this.controlRTS.valueChanges.subscribe(newValue => {
        //this.regConfigNamesObservable = this._regName(newValue);
        this.rtsNamesObservable = this._rtsNameOnKeyDown(newValue);
      })
    }

    this.inputLengthRTS = $event.target.value.length;
    //this.modelRegConfigName = $event.target.value;
    this.modelRTSName = $event.target.value;
    if (this.inputLengthRTS == 0) {
      this.controlRTS.setValue("");
      //let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedRegNames[0]);
      //if (firstSelectedOption) {
      //  this.RegConfigClose_Region = true;
      //  this.controlRegion.setValue("");
      //  firstSelectedOption.deselect();
      //}
      this.autocompleteTriggerCollection.forEach((x, i) => {
        if (i == 1) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedRTSNames[0]);
          if (firstSelectedOption) {
            this.openOrCloseRTS = true;
            this.controlRTS.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });

    }
  }

  _rtsNameOnKeyDown(value: any): string[] {
    let rtsNameValue = '';
    if (typeof value === "string") {
      this.toHighlightRTS = value;
      rtsNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightRTS = value.name;
      rtsNameValue = value.name.toLowerCase();
    }
    return this.rtsNames.filter(option => option.toLowerCase().includes(rtsNameValue) || option.includes('--Select--'));
  }

  OpenAutoCompeleteDailogRTS(init?, closed?) {
    debugger;
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsRTS = false;
      this.rtsNamesObservable = this.rtsNames;
    }

    this.autocompleteTriggerCollection.forEach((x, i) => {
      if (i == 1) {
        if (this.openOrCloseRTS == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseRTS = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrlRTS.nativeElement.blur();
            this.inputCtrlRTS.nativeElement.focus();
            this.toHighlightRTS = this.inputCtrlRTS.nativeElement.value;
            //debugger
            if (this.inputLengthRTS > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedRTSNames.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedRTSNames[0]);
                if (firstSelectedOption) {
                  if (this.initArrowRTS)
                    this.openOrCloseRTS = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrCloseRTS = true;
        }
      }
    });


  }

  initArrowRTS = true;
  SetArrowClickRTS() {
    if (this.initArrowRTS) {
      this.initArrowRTS = false;
    }
  }

  async onRTSNameChange(event) {
    debugger;
    if (event !== undefined && event !== null) {

      this.setLimitedOptionsRTS = true;
      this.rtsNamesObservable = this.rtsNames;

      let selID = event;// parseInt(event);
      this.selectedRTSNames = [selID];
      this.modelRTSName = this.rtsNames.find(item => item == selID.toString()).toString();
      //this.inputLengthRegion = this.modelRegName.length;

      /////////below code is to set default fisrt value of region names in inputbox for autocomplete when config region is selected
      //if (this.regNames.length > 0) {
      //  const defaultValue = this.regionNamesObservable.find(item => item.id === selID); // Set your logic here to find the default
      //  this.controlRegion.setValue(defaultValue);
      //}

    }
    else {
      this.resetRTS(null);
    }

  }

  resetRTS(event) {
    if (event == null) {
      //Reset reg name and list to default
      this.selectedRTSNames = [];
      this.modelRTSName = "";
      this.modelRTSColor = "#ffffff";//reset default color of reg
      //this.selRegionUnderCurrConfig = [];
    }
  }

  //////////////////////////// IVQ Dropdown
  inputLengthIVQ = 0;
  setLimitedOptionsIVQ = true;
  openOrCloseIVQ = false;

  onKeydownIVQ($event) {
    if (!this.setLimitedOptionsIVQ) {
      this.setLimitedOptionsIVQ = true;
      this.controlIVQ.valueChanges.subscribe(newValue => {
        //this.regConfigNamesObservable = this._regName(newValue);
        this.ivqNamesObservable = this._ivqNameOnKeyDown(newValue);
      })
    }

    this.inputLengthIVQ = $event.target.value.length;
    //this.modelRegConfigName = $event.target.value;
    this.modelIVQName = $event.target.value;
    if (this.inputLengthIVQ == 0) {
      this.controlIVQ.setValue("");
      //let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedRegNames[0]);
      //if (firstSelectedOption) {
      //  this.RegConfigClose_Region = true;
      //  this.controlRegion.setValue("");
      //  firstSelectedOption.deselect();
      //}
      this.autocompleteTriggerCollection.forEach((x, i) => {
        if (i == 2) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedIVQNames[0]);
          if (firstSelectedOption) {
            this.openOrCloseIVQ = true;
            this.controlIVQ.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });

    }
  }

  _ivqNameOnKeyDown(value: any): string[] {
    let ivqNameValue = '';
    if (typeof value === "string") {
      this.toHighlightIVQ = value;
      ivqNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightIVQ = value.name;
      ivqNameValue = value.name.toLowerCase();
    }
    return this.ivqNames.filter(option => option.toLowerCase().includes(ivqNameValue) || option.includes('--Select--'));
  }

  OpenAutoCompeleteDailogIVQ(init?, closed?) {
    debugger;
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsIVQ = false;
      this.ivqNamesObservable = this.ivqNames;
    }

    this.autocompleteTriggerCollection.forEach((x, i) => {
      if (i == 2) {
        if (this.openOrCloseIVQ == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseIVQ = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrlIVQ.nativeElement.blur();
            this.inputCtrlIVQ.nativeElement.focus();
            this.toHighlightIVQ = this.inputCtrlIVQ.nativeElement.value;
            //debugger
            if (this.inputLengthIVQ > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedIVQNames.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedIVQNames[0]);
                if (firstSelectedOption) {
                  if (this.initArrowIVQ)
                    this.openOrCloseIVQ = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrCloseIVQ = true;
        }
      }
    });


  }

  initArrowIVQ = true;
  SetArrowClickIVQ() {
    if (this.initArrowIVQ) {
      this.initArrowIVQ = false;
    }
  }

  async onIVQNameChange(event) {
    debugger;
    if (event !== undefined && event !== null) {

      this.setLimitedOptionsIVQ = true;
      this.ivqNamesObservable = this.ivqNames;

      let selID = event;// parseInt(event);
      this.selectedIVQNames = [selID];
      this.modelIVQName = this.ivqNames.find(item => item == selID.toString()).toString();

    }
    else {
      this.resetIVQ(null);
    }

  }

  resetIVQ(event) {
    if (event == null) {
      //Reset reg name and list to default
      this.selectedIVQNames = [];
      this.modelIVQName = "";
      this.modelIVQColor = "#ffffff";//reset default color of reg
      //this.selRegionUnderCurrConfig = [];
    }
  }

  //////////////////////////// PCM Dropdown
  inputLengthPCM = 0;
  setLimitedOptionsPCM = true;
  openOrClosePCM = false;

  onKeydownPCM($event) {
    if (!this.setLimitedOptionsPCM) {
      this.setLimitedOptionsPCM = true;
      this.controlPCM.valueChanges.subscribe(newValue => {
        //this.regConfigNamesObservable = this._regName(newValue);
        this.pcmNamesObservable = this._pcmNameOnKeyDown(newValue);
      })
    }

    this.inputLengthPCM = $event.target.value.length;
    //this.modelRegConfigName = $event.target.value;
    this.modelPCMName = $event.target.value;
    if (this.inputLengthPCM == 0) {
      this.controlPCM.setValue("");
      //let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedRegNames[0]);
      //if (firstSelectedOption) {
      //  this.RegConfigClose_Region = true;
      //  this.controlRegion.setValue("");
      //  firstSelectedOption.deselect();
      //}
      this.autocompleteTriggerCollection.forEach((x, i) => {
        if (i == 3) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedPCMNames[0]);
          if (firstSelectedOption) {
            this.openOrClosePCM = true;
            this.controlPCM.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });

    }
  }

  _pcmNameOnKeyDown(value: any): string[] {
    let pcmNameValue = '';
    if (typeof value === "string") {
      this.toHighlightPCM = value;
      pcmNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightPCM = value.name;
      pcmNameValue = value.name.toLowerCase();
    }
    return this.pcmNames.filter(option => option.toLowerCase().includes(pcmNameValue) || option.includes('--Select--'));
  }

  OpenAutoCompeleteDailogPCM(init?, closed?) {
    debugger;
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsPCM = false;
      this.pcmNamesObservable = this.pcmNames;
    }

    this.autocompleteTriggerCollection.forEach((x, i) => {
      if (i == 3) {
        if (this.openOrClosePCM == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrClosePCM = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrlPCM.nativeElement.blur();
            this.inputCtrlPCM.nativeElement.focus();
            this.toHighlightPCM = this.inputCtrlPCM.nativeElement.value;
            //debugger
            if (this.inputLengthPCM > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedPCMNames.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value == this.selectedPCMNames[0]);
                if (firstSelectedOption) {
                  if (this.initArrowPCM)
                    this.openOrClosePCM = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrClosePCM = true;
        }
      }
    });


  }

  initArrowPCM = true;
  SetArrowClickPCM() {
    if (this.initArrowPCM) {
      this.initArrowPCM = false;
    }
  }

  async onPCMNameChange(event) {
    debugger;
    if (event !== undefined && event !== null) {

      this.setLimitedOptionsPCM = true;
      this.pcmNamesObservable = this.pcmNames;

      let selID = event;// parseInt(event);
      this.selectedPCMNames = [selID];
      this.modelPCMName = this.pcmNames.find(item => item == selID.toString()).toString();

    }
    else {
      this.resetPCM(null);
    }

  }

  resetPCM(event) {
    if (event == null) {
      //Reset reg name and list to default
      this.selectedPCMNames = [];
      this.modelPCMName = "";
      this.modelPCMColor = "#ffffff";//reset default color of reg
      //this.selRegionUnderCurrConfig = [];
    }
  }

  ///////////////////////////////////////////////////////////////END AUTOCOMPLETE DROPDDOWN

  ////////////////////////////////////////////////////////////// common functions
  getPosition(x, y, color) {
    this.element = <Element>this.root;
    this.canvas = <HTMLCanvasElement>document.getElementById("canvas");
    this.ctx = this.canvas.getContext("2d");
    let curleft = 0,
      curtop = 0;


    this.DrawCoordinates(x, y, color);
    //this.drawCoordinates(x, 10, color);
    // this.DrawTriangle(295, 350, 170);

  }

  DrawCoordinates(x, y, color) {
    const grd = this.ctx.createLinearGradient(0, 0, color, 0);
    grd.addColorStop(0, "blue");
    // grd.addColorStop(1, "red");
    this.ctx.fillStyle = grd; // Red color

    this.ctx.beginPath();
    this.ctx.arc(Number(x), Number(y), this.pointSize, 0, Math.PI * 2, true);
    this.ctx.fill();

    //const image = new Image();
    //image.src = "https://cdn4.iconfinder.com/data/icons/essential-app-2/16/play-music-triangle-media-512.png";
    //// Draw a star at coordinates (100, 100)
    //this.ctx.drawImage(image, Number(x), Number(y), 20, 20);
    // load second image

  }

  DrawCoordinatesWithTilte(x, y, color = "#008040", resultType = "", timestampDate = "", score = "", pauseTimerMeanScore = 0, xCordOriginal = 0, yCordOriginal = 0, pcmFileName = "", noOfOutboundFiles = 0) {

    this.xaxis = x;
    this.yaxis = y;
    const width2 = 20; // replace with your desired width
    const height2 = 20; // replace with your desired height

    // const grd = this.ctx.createLinearGradient(0, 0, color, 0); 
    //grd.addColorStop(0, "yellow");
    this.ctx.fillStyle = color; //"#008040"; //grd; // Red color

    this.ctx.beginPath();
    this.ctx.arc(Number(x), Number(y), this.pointSize, 0, Math.PI * 2, true);
    this.ctx.fill();

    // Draw the outline of the triangle
    this.ctx.strokeStyle = "black";
    this.ctx.lineWidth = 1;
    this.ctx.stroke();

    //let title = "<div style='margin-left:5px'><strong>Shape</strong><br>This is Circle shape.</div>";
    let title = "";
    if (pauseTimerMeanScore == 0) {
      if (this.selectedTab == "VQT")
        title = "<div style='margin-left:5px;'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Score = </b>" + (score == "0" ? "N/A" : score) + "</br><b>Uplink</b></div>";
      else
        title = "<div style='margin-left:5px;'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Score = </b>" + (score == "0" ? "N/A" : score) + "</br><b>DAQ Score =</b>" + this.daqScoreResult + "</br> <b>Uplink</b></div>";
    }
    else {
      if (this.selectedTab == "VQT")
        title = "<div style='margin-left:5px;'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Mean Score of (" + noOfOutboundFiles + " files) = </b>" + (score == "0" ? "N/A" : score) + "</br><b>Uplink</b></div>";
      else
        title = "<div style='margin-left:5px;'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Mean Score of (" + noOfOutboundFiles + " files) = </b>" + (score == "0" ? "N/A" : score) + "</br><b>DAQ Score =</b>" + this.daqScoreResult + "</br><b>Uplink</b></div>";
    }

    ///////////////////// BELOW CODE COMMENT AS THIS FUNTIONALITY MAY REQUIRE IT LATER AS PER CUSTOMER DEMANDS

    this.canvas.addEventListener('click', (event) => {
      if ((event.offsetX > x - 10 && event.offsetX < (x + 10)) && (event.offsetY > y - 10 && event.offsetY < y + 10) && pcmFileName != "") {
        //debugger;
        this.ConvertPCMToWAV(pcmFileName);
      }
    });

    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      //this.xaxis = x + 20;
      //this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);

      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within circle 223, 302
      if ((event.offsetX > x - 10 && event.offsetX < (x + 10)) && (event.offsetY > y - 10 && event.offsetY < y + 10)) {
        ////debugger;
        this.isMouseOver = true;
        this.drawTitle(this.canvas, this.ctx, title, x + 320, y + 20, xCordOriginal, yCordOriginal);/// x + 320 and  y + 20  are for positioning the title box        

      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });

  }

  DrawTrianglewithImage(x, y, color) {

    //const grd = this.ctx.createLinearGradient(0, 0, color, 0);
    //grd.addColorStop(0, "blue");
    //this.ctx.fillStyle = grd; // Red color

    //this.ctx.beginPath();
    //const image = new Image();
    //image.src = "https://cdn4.iconfinder.com/data/icons/essential-app-2/16/play-music-triangle-media-512.png";
    //// Draw a star at coordinates (100, 100)

    //this.ctx.drawImage(image, Number(x), Number(y), 20, 20);
    //this.ctx.fill();
    const imageTriangle = new Image();
    imageTriangle.onload = () => {
      // define coordinates for second image
      const x2 = 100; // replace with your desired x coordinate
      const y2 = 100; // replace with your desired y coordinate
      const width2 = 20; // replace with your desired width
      const height2 = 20; // replace with your desired height

      // draw second image on canvas
      this.ctx.drawImage(imageTriangle, x, y, width2, height2);
      // add text to canvas
      this.ctx.font = 'bold 15px Arial';
      this.ctx.fillStyle = 'white';

      // calculate coordinates of the center of the canvas
      const centerX = this.canvas.width / 2;
      const centerY = this.canvas.height / 2;

      // adjust coordinates of the text to center it on the canvas
      const text = 'Hello, world!';
      const textWidth = this.ctx.measureText(text).width;
      const textHeight = 24;
      const textX = centerX - textWidth / 2;
      const textY = centerY + textHeight / 2;

      this.ctx.fillText('5', (x + 8), (y + 12));
    };
    imageTriangle.src = 'https://cdn4.iconfinder.com/data/icons/essential-app-2/16/play-music-triangle-media-512.png'; // replace with your second image path

  }

  DrawSquareWithColor(x, y, color) {

    //const grd = this.ctx.createLinearGradient(0, 0, color, 0);
    //grd.addColorStop(0, "blue");
    //this.ctx.fillStyle = grd; // Red color

    //this.ctx.beginPath();
    //const image = new Image();
    //image.src = "https://cdn4.iconfinder.com/data/icons/essential-app-2/16/play-music-triangle-media-512.png";
    //// Draw a star at coordinates (100, 100)

    //this.ctx.drawImage(image, Number(x), Number(y), 20, 20);
    //this.ctx.fill();
    const imageTriangle = new Image();
    //imageTriangle.onload = () => {
    // define coordinates for second image
    const x2 = 100; // replace with your desired x coordinate
    const y2 = 100; // replace with your desired y coordinate
    const width2 = 20; // replace with your desired width
    const height2 = 20; // replace with your desired height

    // draw second image on canvas
    this.ctx.drawImage(imageTriangle, x, y, width2, height2);
    this.ctx.fillStyle = 'red';
    this.ctx.fillRect(x + 20, y, 20, 20);

    // add text to canvas
    this.ctx.font = 'bold 15px Arial';
    this.ctx.fillStyle = 'white';
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';

    // calculate coordinates of the center of the canvas
    const centerX = this.canvas.width / 2;
    const centerY = this.canvas.height / 2;

    // adjust coordinates of the text to center it on the canvas
    const text = '8';
    const textWidth = this.ctx.measureText(text).width;
    const textHeight = 24;
    const textX = centerX - textWidth / 2;
    const textY = centerY + textHeight / 2;

    this.ctx.fillText(text, (x + 30), (y + 12));

  }

  DrawSquareWithTitle(x, y, color, stepcount = 0, titleData = "", iconType = "", xCordOriginal = 0, yCordOriginal = 0) {

    //const x2 = 100; // replace with your desired x coordinate
    //const y2 = 100; // replace with your desired y coordinate
    const width2 = 15;//20; // replace with your desired width
    const height2 = 15; //20; // replace with your desired height

    // draw second image on canvas
    // this.ctx.drawImage(imageTriangle, x, y, width2, height2);
    this.ctx.fillStyle = 'Red';
    this.ctx.fillRect(x - 6, y - 6, width2, height2); ///to draw rectangle

    // add text to canvas
    this.ctx.font = 'bold 12px Arial';
    this.ctx.fillStyle = 'white';
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';

    // calculate coordinates of the center of the canvas
    const centerX = this.canvas.width / 2;
    const centerY = this.canvas.height / 2;

    // adjust coordinates of the text to center it on the canvas
    const text = stepcount; //'7';
    const textWidth = this.ctx.measureText(text).width;
    const textHeight = 24;
    const textX = centerX - textWidth / 2;
    const textY = centerY + textHeight / 2;

    this.ctx.fillText(text, (x + 2), (y + 3));  //this.ctx.fillText(text, (x + 30), (y + 12));
    this.ctx.setTransform(1, 0, 0, 1, 0, 0); // //the transform matrix is reset to the identity matrix using this.ctx.setTransform(1, 0, 0, 1, 0, 0) to ensure that each star is drawn independently of the others.
    //this.ctx.fillRect(x+20, y, 20, 20);
    // };
    //imageTriangle.src = 'https://cdn4.iconfinder.com/data/icons/essential-app-2/16/play-music-triangle-media-512.png'; // replace with your second image path

    //let title = "<div style='margin-left:5px'><strong>Shape 1</strong><br>This is shape 1.<br>This is shape 1.<br>This is shape 1.<br>This is shape 1.</div>";
    let title = "";
    if (iconType == "")
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br></div>";
    else
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br><b>" + iconType + "</b></div>";
    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {
      // calculate distance between mouse position and target coordinate

      //const dx = event.offsetX - x;
      //const dy = event.offsetY - y;
      //const distance = Math.sqrt(dx * dx + dy * dy);

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      this.xaxis = x;
      this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);
           
      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within square image so check x cordinate within width of square an y shld be between height of square 115 50
      if ((event.offsetX > x - 5 && event.offsetX < x + 10) && (event.offsetY > y - 5 && event.offsetY < y + 10)) {
        this.isMouseOver = true;
        ////debugger;
        this.drawTitle(this.canvas, this.ctx, title, x + 320, y + 40, xCordOriginal, yCordOriginal);
      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y, x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });


  }

  DrawTriangleWith2Corodinates(x, y, color) {
    const width2 = 10; // replace with your desired width
    const height2 = 10;

    // Define the two coordinates of the triangle  
    //const x1 = x;
    //const y1 = x;
    //const x2 = y;
    //const y2 = y;
    const x1 = x;//50
    const y1 = y;//50
    const x2 = x - 10//60;
    const y2 = y + 12//55;
    const x3 = x + 10//55;
    const y3 = y + 12//60;
    // Move to the first coordinate
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);

    // Draw a line to the second coordinate
    this.ctx.lineTo(x2, y2);

    // Draw a line to the top of the triangle (halfway between the two coordinates)
    //const x3 = (x1 + x2) / 4;
    //const y3 = y1 - (y2 - y1) / 4;
    this.ctx.lineTo(x3, y3);

    // Close the path to complete the triangle
    this.ctx.closePath();

    // Fill the triangle with a color
    this.ctx.fillStyle = "yellow";
    this.ctx.fill();

    // Draw the outline of the triangle
    this.ctx.strokeStyle = "black";
    this.ctx.lineWidth = 2;
    this.ctx.stroke();

    let title = "<div style='margin-left:5px'><strong>Shape</strong><br>This is Triangle2 shape.</div>";
    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {
      // calculate distance between mouse position and target coordinate

      //const dx = event.offsetX - x;
      //const dy = event.offsetY - y;
      //const distance = Math.sqrt(dx * dx + dy * dy);

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      //this.xaxis = x + 20;
      //this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);

      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within square image so check x cordinate within width of square an y shld be between height of square
      if ((event.offsetX > x - 10 && event.offsetX < (x + width2)) && (event.offsetY > y && event.offsetY < y + height2)) {
        this.isMouseOver = true;
        this.drawTitle(this.canvas, this.ctx, title, x + 500, y + 45, x, y);/// 10 and 20  are for positioning the title box
      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });

  }

  DrawTriangleWithTitle(x, y, color = "#008040", resultType = "", timestampDate = "", score = "", pauseTimerMeanScore = 0, xCordOriginal = 0, yCordOriginal = 0, pcmFileName = "", noOfInboundFiles = 0) {

    //this.xaxis = x;
    //this.yaxis = y;
    const width2 = 10; // replace with your desired width
    const height2 = 10; // replace with your desired height

    // Define the two coordinates of the triangle
    //const x1 = x;
    //const y1 = x;
    //const x2 = y;
    //const y2 = y;
    const x1 = x;//50
    const y1 = y;//50
    const x2 = x - 8//60;
    const y2 = y + 8//55;
    const x3 = x + 8//55;
    const y3 = y + 8//60;
    // Move to the first coordinate
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);

    // Draw a line to the second coordinate
    this.ctx.lineTo(x2, y2 + 6);

    // Draw a line to the top of the triangle (halfway between the two coordinates)
    //const x3 = (x1 + x2) / 4;
    //const y3 = y1 - (y2 - y1) / 4;
    this.ctx.lineTo(x3, y3 + 6);

    // Close the path to complete the triangle
    this.ctx.closePath();

    // Fill the triangle with a color
    this.ctx.fillStyle = color; //"#008040";
    this.ctx.fill();

    // Draw the outline of the triangle
    this.ctx.strokeStyle = "black";
    this.ctx.lineWidth = 1;
    this.ctx.stroke();

    //let title = "<div style='margin-left:5px'><strong>Shape</strong><br>This is Triangle shape.</div>"; <b>DAQ Score =</b>"+this.daqScoreResult+"</br>

    let title = "";
    if (pauseTimerMeanScore == 0) {
      if (this.selectedTab == "VQT")
        title = "<div style='margin-left:5px'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Score = </b>" + (score == "0" ? "N/A" : score) + "</br><b>Downlink</b></div>";
      else
        title = "<div style='margin-left:5px'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Score = </b>" + (score == "0" ? "N/A" : score) + "</br><b>DAQ Score =</b>" + this.daqScoreResult + "</br><b>Downlink</b></div>";

    }
    else {
      if (this.selectedTab == "VQT") {
        title = "<div style='margin-left:5px'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Mean Score of (" + noOfInboundFiles + " files)= </b>" + (score == "0" ? "N/A" : score) + "</br><b>Downlink</b></div>";
      }
      else {
        title = "<div style='margin-left:5px'><b>VQuad Timestamp = </b>" + timestampDate + "</br><b>" + resultType + " Mean Score of (" + noOfInboundFiles + " files) = </b>" + (score == "0" ? "N/A" : score) + "</br><b>DAQ Score =</b>" + this.daqScoreResult + "</br><b>Downlink</b></div>";
      }
    }


    ///////////////////// BELOW CODE COMMENT AS THIS FUNTIONALITY MAY REQUIRE IT LATER AS PER CUSTOMER DEMANDS

    ////// onclick convert pcm file to wav and play in audioplayer
    this.canvas.addEventListener('click', (event) => {
      if ((event.offsetX > x - 10 && event.offsetX < (x + 10)) && (event.offsetY > y - 10 && event.offsetY < y + 10) && pcmFileName != "") {
        //debugger;
        this.ConvertPCMToWAV(pcmFileName);
      }
    });
    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {
      // calculate distance between mouse position and target coordinate


      //const dx = event.offsetX - x;
      //const dy = event.offsetY - y;
      //const distance = Math.sqrt(dx * dx + dy * dy);

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      //this.xaxis = x + 20;
      //this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);

      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within square image so check x cordinate within width of square an y shld be between height of square 435, 250,
      if ((event.offsetX > x - 10 && event.offsetX < (x + 10)) && (event.offsetY > y - 10 && event.offsetY < y + 10)) {
        this.isMouseOver = true;
        this.drawTitle(this.canvas, this.ctx, title, x + 320, y+20 , xCordOriginal, yCordOriginal);/// x + 350 and y + 70  are for positioning the title box


      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });


  }

  DrawTriangleWithSmalSize(x, y, color, titleData = "", iconType = "", xCordOriginal = 0, yCordOriginal = 0) {

    //this.xaxis = x;
    //this.yaxis = y;
    const width2 = 10; // replace with your desired width
    const height2 = 10; // replace with your desired height

    // Define the two coordinates of the triangle
    //const x1 = x;
    //const y1 = x;
    //const x2 = y;
    //const y2 = y;
    const x1 = x;//50
    const y1 = y;//50
    const x2 = x - 6//60;
    const y2 = y + 6//55;
    const x3 = x + 6//55;
    const y3 = y + 6//60;
    // Move to the first coordinate
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);

    // Draw a line to the second coordinate
    this.ctx.lineTo(x2, y2);

    // Draw a line to the top of the triangle (halfway between the two coordinates)
    //const x3 = (x1 + x2) / 4;
    //const y3 = y1 - (y2 - y1) / 4;
    this.ctx.lineTo(x3, y3);

    // Close the path to complete the triangle
    this.ctx.closePath();

    // Fill the triangle with a color
    this.ctx.fillStyle = "blue";
    this.ctx.fill();

    // Draw the outline of the triangle
    //this.ctx.strokeStyle = "black";
    //this.ctx.lineWidth = 1;
    //this.ctx.stroke();

    //let title = "<div style='margin-left:5px'><strong>Shape</strong><br>This is Triangle shape.</div>";
    let title = "";
    if (iconType == "")
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br></div>";
    else
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br><b>" + iconType + "</b></div>";

    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {
      // calculate distance between mouse position and target coordinate

      //const dx = event.offsetX - x;
      //const dy = event.offsetY - y;
      //const distance = Math.sqrt(dx * dx + dy * dy);

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      //this.xaxis = x + 20;
      //this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);

      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within square image so check x cordinate within width of square an y shld be between height of square
      if ((event.offsetX > x - 10 && event.offsetX < (x + width2)) && (event.offsetY > y && event.offsetY < y + height2)) {
        this.isMouseOver = true;
        this.drawTitle(this.canvas, this.ctx, title, x + 350, y + 70, xCordOriginal, yCordOriginal);/// 10 and 20  are for positioning the title box
      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });


  }

  DrawStartWithColor(x, y, color) {
    //const x = 50;
    //const y = 50;
    // x = 150;
    // y = 150;
    // const size = 20;

    const radius = 12;
    const spikeLength = 5;

    this.ctx.beginPath();
    this.ctx.translate(x, y);
    this.ctx.moveTo(0, 0 - radius);
    for (var i = 0; i < 5; i++) {
      this.ctx.rotate(Math.PI / 5);
      this.ctx.lineTo(0, 0 - (radius * 0.4));
      this.ctx.rotate(Math.PI / 5);
      this.ctx.lineTo(0, 0 - radius);
    }
    this.ctx.closePath();

    this.ctx.fillStyle = "blue";
    this.ctx.fill();
    this.ctx.setTransform(1, 0, 0, 1, 0, 0); // //the transform matrix is reset to the identity matrix using this.ctx.setTransform(1, 0, 0, 1, 0, 0) to ensure that each star is drawn independently of the others.
  }

  DrawSmallStartWithTitle(x, y, color, titleData = "", iconType = "", xCordOriginal = 0, yCordOriginal = 0) {
    //const x = 50;
    //const y = 50;
    //x = 150;
    //y = 150;
    // const size = 20;

    this.xaxis = x;
    this.yaxis = y;
    const width2 = 8; // replace with your desired width
    const height2 = 8; // replace with your desired height

    const radius1 = 8;
    const spikeLength1 = 5;

    this.ctx.beginPath();
    this.ctx.translate(x, y);
    this.ctx.moveTo(0, 0 - radius1);
    for (var i = 0; i < 5; i++) {
      this.ctx.rotate(Math.PI / 5);
      this.ctx.lineTo(0, 0 - (radius1 * 0.4));
      this.ctx.rotate(Math.PI / 5);
      this.ctx.lineTo(0, 0 - radius1);
    }
    this.ctx.closePath();

    this.ctx.fillStyle = "blue";
    this.ctx.fill();
    this.ctx.setTransform(1, 0, 0, 1, 0, 0); //the transform matrix is reset to the identity matrix using this.ctx.setTransform(1, 0, 0, 1, 0, 0) to ensure that each star is drawn independently of the others.

    //let title = "<div style='margin-left:5px'><strong>Shape</strong><br>This is star shape.</div>";
    let title = "";
    if (iconType == "")
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br></div>";
    else
      title = "<div style='margin-left:5px'><b>Timestamp =</b>" + titleData + "<br><b>" + iconType + "</b></div>";
    // add mouseover event listener
    this.canvas.addEventListener('mousemove', (event) => {
      // calculate distance between mouse position and target coordinate

      //const dx = event.offsetX - x;
      //const dy = event.offsetY - y;
      //const distance = Math.sqrt(dx * dx + dy * dy);

      this.dx = event.offsetX;
      this.dy = event.offsetY;
      this.distsqrt = 0;// distance;

      //this.xaxis = x + 20;
      //this.yaxis = y;
      this.distsqrtxy = Math.sqrt(x * x + y * y);

      // show title if distance is less than 50 pixels
      //if (distance<50)
      /// show title only within square image so check x cordinate within width of square an y shld be between height of square
      if ((event.offsetX > x - 10 && event.offsetX < (x + width2)) && (event.offsetY > y - 10 && event.offsetY < y + height2)) {
        this.isMouseOver = true;
        this.drawTitle(this.canvas, this.ctx, title, x + 350, y + 70, xCordOriginal, yCordOriginal);/// 10 and 20  are for positioning the title box
      } else {
        ////debugger;
        this.isMouseOver = false;
        //this.drawTitle(this.canvas, this.ctx, '', x, y);
        this.titleRef.nativeElement.style.display = 'none';
      }
    });



  }

  DrawCoordinatesBetween2Point(x, y, color) {

    // Set the starting point of the line
    const x1 = 150;
    const y1 = 200;
    this.ctx.moveTo(x1, y1);
    this.DrawSquareWithTitle(x1 - 20, y1, color);

    // Set the end point of the line
    const x2 = 400;
    const y2 = 200;
    this.ctx.lineTo(x2, y2);
    this.DrawSquareWithTitle(x2 - 20, y2, color);

    // Set the line color and width
    this.ctx.strokeStyle = 'yellow';
    this.ctx.lineWidth = 2;

    // Draw the line on the canvas
    this.ctx.stroke();

    ///////////////draw circles through the lines
    const numCircles = 8;
    const deltaX = (x2 - x1) / (numCircles + 1);
    const deltaY = (y2 - y1) / (numCircles + 1);

    for (let i = 1; i <= numCircles; i++) {
      const x = x1 + i * deltaX;
      const y = y1 + i * deltaY;
      //this.ctx.beginPath();
      //this.ctx.arc(x, y, this.pointSize, 0, 2 * Math.PI);
      //this.ctx.stroke();
      this.DrawCoordinatesWithTilte(x, y, "blue", "", "");
    }

  }

  DrawMultiSymbolAtSameCordinate_Pause(x, y, color) {
    this.DrawTriangleWithTitle(x + 10, y - 12, color, x, y);
    this.DrawSquareWithTitle(x - 20, y, color, x, y);
    this.DrawCoordinatesWithTilte(x + 10, y + 30, color, x, y);
    this.DrawTriangleWithSmalSize(x + 30, y - 8, color, x, y);
  }

  DrawMultiSymbolAtSameCordinate_PauseTimer(x, y, color, ivqFilteredData, resultType) {
    debugger;
    let inboundMeanScore = 0;
    let outboundMeanScore = 0;
    let inboundtimestampDate = "N/A";
    let outboundtimestampDate = "N/A";

    let inboundList = ivqFilteredData.filter(m => m.inoutbound == "I" && m.yAxis.includes("~"));
    let outboundList = ivqFilteredData.filter(m => m.inoutbound == "O" && m.yAxis.includes("~"));

    //if (inboundList.length > 0)
    //  inboundtimestampDate = inboundList[0].eventDate + " To " + inboundList[inboundList.length - 1].eventDate;

    //if (outboundList.length > 0)
    //   outboundtimestampDate = outboundList[0].eventDate + " To " + outboundList[outboundList.length - 1].eventDate;

    if (inboundList.length > 0) {
      inboundtimestampDate = inboundList[0].eventDate + "</br> To " + inboundList[inboundList.length - 1].eventDate;
      inboundMeanScore = (inboundList.reduce((acc, curr) => acc + Number(curr['score']), 0)) / inboundList.length; ///add all scrore and divide it by no of score count to get mean score
      inboundMeanScore = Number(inboundMeanScore.toFixed(2));
    }
    if (outboundList.length > 0) {
      outboundtimestampDate = outboundList[0].eventDate + "</br> To " + outboundList[outboundList.length - 1].eventDate;
      outboundMeanScore = (outboundList.reduce((acc, curr) => acc + Number(curr['score']), 0)) / outboundList.length; ///add all scrore and divide it by no of score count to get mean score
      outboundMeanScore = Number(outboundMeanScore.toFixed(2));
    }

    //debugger;
    this.DrawTriangleWithTitle(x + 2, y - 20, this.GetColorBasedOnScore(inboundMeanScore), resultType, inboundtimestampDate, inboundMeanScore.toString(), 1, x, y, "", inboundList.length);
    //this.DrawSquareWithTitle(x - 20, y, color);
    this.DrawCoordinatesWithTilte(x + 1, y + 17, this.GetColorBasedOnScore(outboundMeanScore), resultType, outboundtimestampDate, outboundMeanScore.toString(), 1, x, y, "", outboundList.length);
    //this.DrawTriangleWithSmalSize(x + 30, y - 8, color);
  }

  DrawMultiSymbolAtSameCordinate_SquareStar_Stop(x, y, color, stepcount = 0, titleData = "") {
    this.DrawSmallStartWithTitle(x + 15, y - 10, color, titleData, "Pause", x, y);
    this.DrawSquareWithTitle(x, y, color, stepcount, titleData, "Pause", x, y); ////-1 = stop/pause;
  }

  DrawMultiSymbolAtSameCordinate_SquareTriangle(x, y, color, stepcount = 0, titleData = "", iconType = "") {
    this.DrawTriangleWithSmalSize(x + 15, y - 10, color, titleData, "PauseTimer (sec) = " + iconType, x, y);
    this.DrawSquareWithTitle(x, y, color, stepcount, titleData, "PauseTimer (sec) = " + iconType, x, y);///30=PauseTimer 
  }

  DrawMultiSymolBetween2CoordinatePoint(xStart, yStart, xEnd, yEnd, ivqFilteredData, resultType) {

    // Set the starting point of the line
    const x1 = xStart;//150;
    const y1 = yStart;//200;
    this.ctx.moveTo(x1, y1);
    //this.DrawSquareWithTitle(x1 - 20, y1, color);

    // Set the end point of the line
    const x2 = xEnd;//400;
    const y2 = yEnd;//200;
    this.ctx.lineTo(x2, y2);
    //this.DrawSquareWithTitle(x2 - 20, y2, color);

    // Set the line color and width
    //this.ctx.strokeStyle = 'yellow';
    //this.ctx.lineWidth = 2;

    // Draw the line on the canvas
    //this.ctx.stroke();

    ///////////////draw circles through the lines
    const numOfSymbol = ivqFilteredData.length //8;
    const deltaX = (x2 - x1) / (numOfSymbol + 1);
    const deltaY = (y2 - y1) / (numOfSymbol + 1);

    for (let i = 0; i < numOfSymbol; i++) {
      const x = x1 + (i + 1) * deltaX;
      const y = y1 + (i + 1) * deltaY;

      if (this.selectedTab == "DAQ" && this.filteredDAQPesqScore != undefined)
        this.daqScoreResult = ivqFilteredData[i].daqScoreResult;

      //this.ctx.beginPath();
      //this.ctx.arc(x, y, this.pointSize, 0, 2 * Math.PI);
      //this.ctx.stroke();
      if (ivqFilteredData[i].inoutbound == "O")//outbound
        this.DrawCoordinatesWithTilte(x, y, ivqFilteredData[i].iconColor, resultType, ivqFilteredData[i].eventDate, ivqFilteredData[i].score, 0, xStart, yStart, ivqFilteredData[i].pcmFileName);
      else///Inbound
        this.DrawTriangleWithTitle(x, y - 5, ivqFilteredData[i].iconColor, resultType, ivqFilteredData[i].eventDate, ivqFilteredData[i].score, 0, xStart, yStart, ivqFilteredData[i].pcmFileName);
    }

  }

  // helper function to draw title on canvas
  drawTitle(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, title: string, x, y, xCordOrginal, yCordOriginal): void {
    // clear canvas
    //ctx.clearRect(0, 0, x, y);///ctx.clearRect(0, 0, canvas.width, 60);///60
    this.titleRef.nativeElement.style.display = 'none';

    //ctx.clearRect(0, 0, canvas.width, 60);


    // draw title if mouse is over canvas
    if (this.isMouseOver && this.CheckValidCooOdinates(xCordOrginal, yCordOriginal)) {
      ////////////
      setTimeout(() => {

        ctx.font = 'bold 24px Arial';
        ctx.fillStyle = 'yellow';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const titleX = canvas.width / 2;
        const titleY = 30;
        //ctx.fillText(title, x, y);

        if (this.status1)
          this.titleRef.nativeElement.style.left = x + 25 + 'px'; // '233px';
        else
          this.titleRef.nativeElement.style.left = x - 250 + 'px'; // previously it was 300

        ///to adjust tootltip when image panel is goes down after resizing
        if (this.windowMinimized && this.status1) {
          this.titleRef.nativeElement.style.left = x - 250 + 'px'; // '233px';       
          this.titleRef.nativeElement.style.top = y + 500 + 'px'; // '265px';
        }
        else
          this.titleRef.nativeElement.style.top = y + 'px'; // '265px';

        ///this is used  bcoz title showing for circle having issue
        setTimeout(() => {
          this.titleRef.nativeElement.style.display = 'block';
        }, 10);
        this.titleRef.nativeElement.style.display = 'block';
        this.titleRef.nativeElement.innerHTML = title;

        return;
      }, 300);
    }
    else {
      this.titleRef.nativeElement.style.display = 'none';
      return;
    }
  }
  CheckValidCooOdinates(xCordOrginal: any, yCordOriginal: any): any {
    ////debugger;

    let cordExists = this.rtsData.filter(m => m.xAxis == xCordOrginal && m.yAxis == yCordOriginal);
    if (cordExists.length > 0)
      return true;
    else
      return false;

  }

  getPosition1(x, y) {
    this.element = <Element>this.root;
    this.canvas = <HTMLCanvasElement>document.getElementById("canvas");
    this.ctx = this.canvas.getContext("2d");
    let curleft = 0,
      curtop = 0;

    //curleft += event.offsetX;
    //curtop += event.offsetY;
    //this.drawCoordinates(x, y);
  }

  onddlChange(id) {
    this.selectedSampleRate = [id];
  }

  //////////////////////////////////////////////////// SERVICES
  GetRTSData_Service(formData: FormData) {
    // multipart/form-data
    //var headerOptions = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    var headerOptions = new HttpHeaders();
    let options = {
      headers: headerOptions
    };
    return this.http.post<any>(this.url, formData);

  }

  GetITSRating_Service() {
    // multipart/form-data
    //var headerOptions = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    var headerOptions = new HttpHeaders();
    let options = {
      headers: headerOptions
    };
    return this.http.post<any>(this.url, options);

  }

  GetITSFiles_Service(folderPath, SavePath) {
    var headerOptions = new HttpHeaders();
    let options = {
      headers: headerOptions,
      params: new HttpParams()
        .set('folderPath', folderPath)
        .set('SavePath', SavePath),
    };

    // Make a GET request to fetch the image
    return this.http.post<any>(this.url, {}, options);
  }

  GetImageFromRemoteServerPath_Service(filePath) {
    // multipart/form-data
    //var headerOptions = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    // Encode the file path
    const encodedFilePath = encodeURIComponent(filePath);
    //console.log(encodedFilePath);
    //console.log('ecodedfilepath');
    //let params = new HttpParams()
    //  .set('ImageFilePath', filePath.toString());

    //var headerOptions = new HttpHeaders();
    //let options = {
    //  headers: headerOptions,
    //  params: params
    //};
    //return this.http.get(this.url, { responseType: 'blob' });

    // Prepare the HTTP options, no need for headers in this case since we are just getting an image
    const options = {
      params: new HttpParams().set('ImageFilePath', filePath),
      responseType: 'blob' as 'json'  // The 'as json' is needed to satisfy TypeScript
    };

    // Make a GET request to fetch the image
    return this.http.get<Blob>(this.url, options);

  }

  LoadRTSFileFromRemoteServerPath_Service(filePath) {
    // Encode the file path
    const encodedFilePath = encodeURIComponent(filePath);
    //console.log(encodedFilePath);
    //console.log('ecodedfilepath');

    let headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });

    const options = {
      headers: headerOptions,
      params: new HttpParams().set('RTSFilePath', filePath)
    };

    // Make a GET request to fetch the image
    return this.http.get<any>(this.url, options);

  }

  GetIVQFileFromRemoteServerPath_Service(filePath) {
    // multipart/form-data
    //var headerOptions = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    // Encode the file path
    const encodedFilePath = encodeURIComponent(filePath);
    //console.log(encodedFilePath);
    //console.log('ecodedfilepath');
    //let params = new HttpParams()
    //  .set('ImageFilePath', filePath.toString());

    //var headerOptions = new HttpHeaders();
    //let options = {
    //  headers: headerOptions,
    //  params: params
    //};
    //return this.http.get(this.url, { responseType: 'blob' });

    // Prepare the HTTP options, no need for headers in this case since we are just getting an image
    const options = {
      params: new HttpParams().set('IVQFilePath', filePath),
      responseType: 'blob' as 'json'  // The 'as json' is needed to satisfy TypeScript
    };

    // Make a GET request to fetch the image
    return this.http.get<Blob>(this.url, options);

  }

  SaveITSRating_Service(params) {
    // multipart/form-data
    //var headerOptions = new HttpHeaders({ 'Conte  nt-Type': 'multipart/form-data' });
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions,

    };


    return this.http.post<any>(this.url, params, options);

  }

  ConvertPCMToWav_Service(pcmFolderName: string, pcmFileName: string, sampleRate: number) {
    let params = new HttpParams()
      .set('sampleRate', sampleRate.toString())
      .set('pcmFolderName', pcmFolderName)
      .set('pcmFileName', pcmFileName)

    //let body = {
    // // pcmFolderName: pcmFolderName,
    // // pcmFileName: pcmFileName,
    //  sampleRate: sampleRate.toString()
    //};

    ///let headers = new HttpHeaders(); for formdata
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });///new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    };

    //return this.http.post<any>(this.url, formData,options);
    return this.http.post<any>(this.url, null, options);
  }

  SendPCMFile_Service(formData: FormData, sampleRate: number) {

    let params = new HttpParams()
      .set('sampleRateSpeed', sampleRate.toString())

    var headerOptions = new HttpHeaders();
    let options = {
      params: params
    };
    return this.http.post<any>(this.url, formData, options);

  }

  DAQScoreTable: any[] = [
    { pesqScoreRange: '-0.500-0.906', daq: 0.00 },
    { pesqScoreRange: '0.907-0.958', daq: 0.10 },
    { pesqScoreRange: '0.959-1.011', daq: 0.20 },
    { pesqScoreRange: '1.012-1.063', daq: 0.30 },
    { pesqScoreRange: '1.064-1.116', daq: 0.40 },
    { pesqScoreRange: '1.117-1.169', daq: 0.50 },
    { pesqScoreRange: '1.170-1.222', daq: 0.60 },
    { pesqScoreRange: '1.223-1.274', daq: 0.70 },
    { pesqScoreRange: '1.275-1.327', daq: 0.80 },
    { pesqScoreRange: '1.328-1.380', daq: 0.90 },
    { pesqScoreRange: '1.381-1.433', daq: 1.00 },

    { pesqScoreRange: '1.434-1.485', daq: 1.10 },
    { pesqScoreRange: '1.486-1.538', daq: 1.20 },
    { pesqScoreRange: '1.539-1.591', daq: 1.30 },
    { pesqScoreRange: '1.592-1.644', daq: 1.40 },
    { pesqScoreRange: '1.645-1.696', daq: 1.50 },
    { pesqScoreRange: '1.697-1.749', daq: 1.60 },
    { pesqScoreRange: '1.750-1.802', daq: 1.70 },
    { pesqScoreRange: '1.803-1.854', daq: 1.80 },
    { pesqScoreRange: '1.855-1.907', daq: 1.90 },
    { pesqScoreRange: '1.908-1.960', daq: 2.00 },

    { pesqScoreRange: '1.961-2.013', daq: 2.10 },
    { pesqScoreRange: '2.014-2.065', daq: 2.20 },
    { pesqScoreRange: '2.066-2.118', daq: 2.30 },
    { pesqScoreRange: '2.119-2.171', daq: 2.40 },
    { pesqScoreRange: '2.172-20224', daq: 2.50 },
    { pesqScoreRange: '2.225-2.276', daq: 2.60 },
    { pesqScoreRange: '2.227-2.329', daq: 2.70 },
    { pesqScoreRange: '2.330-2.382', daq: 2.80 },
    { pesqScoreRange: '2.383-2.434', daq: 2.90 },
    { pesqScoreRange: '2.435-2.487', daq: 3.00 },

    { pesqScoreRange: '2.488-2.540', daq: 3.10 },
    { pesqScoreRange: '2.541-2.593', daq: 3.20 },
    { pesqScoreRange: '2.594-2.645', daq: 3.30 },
    { pesqScoreRange: '2.646-2.698', daq: 3.40 },
    { pesqScoreRange: '2.699-2.751', daq: 3.50 },
    { pesqScoreRange: '2.752-2.804', daq: 3.60 },
    { pesqScoreRange: '2.805-2.858', daq: 3.70 },
    { pesqScoreRange: '2.857-2.909', daq: 3.80 },
    { pesqScoreRange: '2.910-2.962', daq: 3.90 },
    { pesqScoreRange: '2.960-3.015', daq: 4.00 },

    { pesqScoreRange: '3.016-3.067', daq: 4.10 },
    { pesqScoreRange: '3.068-3.120', daq: 4.20 },
    { pesqScoreRange: '3.121-3.173', daq: 4.30 },
    { pesqScoreRange: '3.174-3.225', daq: 4.40 },
    { pesqScoreRange: '3.226-3.278', daq: 4.50 },
    { pesqScoreRange: '3.279-3.331', daq: 4.60 },
    { pesqScoreRange: '3.332-3.384', daq: 4.70 },
    { pesqScoreRange: '3.385-3.436', daq: 4.80 },
    { pesqScoreRange: '3.437-3.489', daq: 4.90 },
    { pesqScoreRange: '3.490-4.500', daq: 5.00 },

  ];

  SampleRateList: SelectItem[] = [
    { id: '8000', name: '8000' },
    { id: '16000', name: '16000' },
    { id: '48000', name: '48000' },
  ];

}

//////////////////////////////////////////// class
interface Window {
  innerWidth: number;
}

class RTSFileData {
  xAxis: any;
  yAxis: any;
  eventDate: string;
  iconColor: string;
  iconType: string;
}

class IVQFileData {
  xAxis: any;
  yAxis: any;
  eventDate: string;
  iconColor: string;
  iconType: string;
  score: string;
  rating: string;
  inoutbound: string;
  pcmFileName: string;
  daqScoreResult: string;
}


